/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var GroupChangeMemberRights_pb = require('./GroupChangeMemberRights_pb.js');
goog.exportSymbol('proto.proto.Avatar', null, global);
goog.exportSymbol('proto.proto.ChannelRoom', null, global);
goog.exportSymbol('proto.proto.ChannelRoom.PrivateExtra', null, global);
goog.exportSymbol('proto.proto.ChannelRoom.PublicExtra', null, global);
goog.exportSymbol('proto.proto.ChannelRoom.Role', null, global);
goog.exportSymbol('proto.proto.ChannelRoom.Type', null, global);
goog.exportSymbol('proto.proto.ChatRoom', null, global);
goog.exportSymbol('proto.proto.ClientAction', null, global);
goog.exportSymbol('proto.proto.Device', null, global);
goog.exportSymbol('proto.proto.Discovery', null, global);
goog.exportSymbol('proto.proto.Discovery.DiscoveryModel', null, global);
goog.exportSymbol('proto.proto.DiscoveryField', null, global);
goog.exportSymbol('proto.proto.DiscoveryField.ButtonActionType', null, global);
goog.exportSymbol('proto.proto.Favorite', null, global);
goog.exportSymbol('proto.proto.File', null, global);
goog.exportSymbol('proto.proto.Gender', null, global);
goog.exportSymbol('proto.proto.GroupRoom', null, global);
goog.exportSymbol('proto.proto.GroupRoom.PrivateExtra', null, global);
goog.exportSymbol('proto.proto.GroupRoom.PublicExtra', null, global);
goog.exportSymbol('proto.proto.GroupRoom.Role', null, global);
goog.exportSymbol('proto.proto.GroupRoom.Type', null, global);
goog.exportSymbol('proto.proto.IVandActivity', null, global);
goog.exportSymbol('proto.proto.Language', null, global);
goog.exportSymbol('proto.proto.MplSale', null, global);
goog.exportSymbol('proto.proto.MplSale.Status', null, global);
goog.exportSymbol('proto.proto.MplTransaction', null, global);
goog.exportSymbol('proto.proto.MplTransaction.Bill', null, global);
goog.exportSymbol('proto.proto.MplTransaction.CardToCard', null, global);
goog.exportSymbol('proto.proto.MplTransaction.Sales', null, global);
goog.exportSymbol('proto.proto.MplTransaction.Topup', null, global);
goog.exportSymbol('proto.proto.MplTransaction.Type', null, global);
goog.exportSymbol('proto.proto.Originator', null, global);
goog.exportSymbol('proto.proto.Pagination', null, global);
goog.exportSymbol('proto.proto.Platform', null, global);
goog.exportSymbol('proto.proto.Poll', null, global);
goog.exportSymbol('proto.proto.PollField', null, global);
goog.exportSymbol('proto.proto.PostMessageRights', null, global);
goog.exportSymbol('proto.proto.PrivacyLevel', null, global);
goog.exportSymbol('proto.proto.PrivacyType', null, global);
goog.exportSymbol('proto.proto.RegisteredUser', null, global);
goog.exportSymbol('proto.proto.RegisteredUser.Status', null, global);
goog.exportSymbol('proto.proto.Room', null, global);
goog.exportSymbol('proto.proto.Room.Type', null, global);
goog.exportSymbol('proto.proto.RoomAccess', null, global);
goog.exportSymbol('proto.proto.RoomDraft', null, global);
goog.exportSymbol('proto.proto.RoomMessage', null, global);
goog.exportSymbol('proto.proto.RoomMessage.Author', null, global);
goog.exportSymbol('proto.proto.RoomMessage.Author.Room', null, global);
goog.exportSymbol('proto.proto.RoomMessage.Author.User', null, global);
goog.exportSymbol('proto.proto.RoomMessage.ChannelExtra', null, global);
goog.exportSymbol('proto.proto.RoomMessage.ExtraType', null, global);
goog.exportSymbol('proto.proto.RoomMessageContact', null, global);
goog.exportSymbol('proto.proto.RoomMessageForwardFrom', null, global);
goog.exportSymbol('proto.proto.RoomMessageLocation', null, global);
goog.exportSymbol('proto.proto.RoomMessageLog', null, global);
goog.exportSymbol('proto.proto.RoomMessageLog.ExtraType', null, global);
goog.exportSymbol('proto.proto.RoomMessageLog.TargetUser', null, global);
goog.exportSymbol('proto.proto.RoomMessageLog.Type', null, global);
goog.exportSymbol('proto.proto.RoomMessageReaction', null, global);
goog.exportSymbol('proto.proto.RoomMessageStatus', null, global);
goog.exportSymbol('proto.proto.RoomMessageStory', null, global);
goog.exportSymbol('proto.proto.RoomMessageStory.Status', null, global);
goog.exportSymbol('proto.proto.RoomMessageStoryForward', null, global);
goog.exportSymbol('proto.proto.RoomMessageStoryReply', null, global);
goog.exportSymbol('proto.proto.RoomMessageType', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.Bill', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.CardToCard', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.MoneyTransfer', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.Topup', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.Topup.Type', null, global);
goog.exportSymbol('proto.proto.RoomMessageWallet.Type', null, global);
goog.exportSymbol('proto.proto.RoomMute', null, global);
goog.exportSymbol('proto.proto.RoomType', null, global);
goog.exportSymbol('proto.proto.Story', null, global);
goog.exportSymbol('proto.proto.Story.Type', null, global);
goog.exportSymbol('proto.proto.Thumbnail', null, global);
goog.exportSymbol('proto.proto.Wallpaper', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageLocation.displayName = 'proto.proto.RoomMessageLocation';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    lat: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    lon: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageLocation}
 */
proto.proto.RoomMessageLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageLocation;
  return proto.proto.RoomMessageLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageLocation}
 */
proto.proto.RoomMessageLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLon();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.proto.RoomMessageLocation.prototype.getLat = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.proto.RoomMessageLocation.prototype.setLat = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lon = 2;
 * @return {number}
 */
proto.proto.RoomMessageLocation.prototype.getLon = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.proto.RoomMessageLocation.prototype.setLon = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageLog.displayName = 'proto.proto.RoomMessageLog';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageLog.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    extraType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    targetUser: (f = msg.getTargetUser()) && proto.proto.RoomMessageLog.TargetUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageLog}
 */
proto.proto.RoomMessageLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageLog;
  return proto.proto.RoomMessageLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageLog}
 */
proto.proto.RoomMessageLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.RoomMessageLog.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.RoomMessageLog.ExtraType} */ (reader.readEnum());
      msg.setExtraType(value);
      break;
    case 3:
      var value = new proto.proto.RoomMessageLog.TargetUser;
      reader.readMessage(value,proto.proto.RoomMessageLog.TargetUser.deserializeBinaryFromReader);
      msg.setTargetUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExtraType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTargetUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.RoomMessageLog.TargetUser.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RoomMessageLog.Type = {
  USER_JOINED: 0,
  USER_DELETED: 1,
  ROOM_CREATED: 2,
  MEMBER_ADDED: 3,
  MEMBER_KICKED: 4,
  MEMBER_LEFT: 5,
  ROOM_CONVERTED_TO_PUBLIC: 6,
  ROOM_CONVERTED_TO_PRIVATE: 7,
  MEMBER_JOINED_BY_INVITE_LINK: 8,
  ROOM_DELETED: 9,
  MISSED_VOICE_CALL: 10,
  MISSED_VIDEO_CALL: 11,
  MISSED_SCREEN_SHARE: 12,
  MISSED_SECRET_CHAT: 13,
  PINNED_MESSAGE: 14,
  CHANGE_PHONE_NUMBER: 15
};

/**
 * @enum {number}
 */
proto.proto.RoomMessageLog.ExtraType = {
  NO_EXTRA: 0,
  TARGET_USER: 1
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageLog.TargetUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageLog.TargetUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageLog.TargetUser.displayName = 'proto.proto.RoomMessageLog.TargetUser';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageLog.TargetUser.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageLog.TargetUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageLog.TargetUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLog.TargetUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageLog.TargetUser}
 */
proto.proto.RoomMessageLog.TargetUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageLog.TargetUser;
  return proto.proto.RoomMessageLog.TargetUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageLog.TargetUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageLog.TargetUser}
 */
proto.proto.RoomMessageLog.TargetUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageLog.TargetUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageLog.TargetUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageLog.TargetUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageLog.TargetUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.proto.RoomMessageLog.TargetUser.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageLog.TargetUser.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional Type type = 1;
 * @return {!proto.proto.RoomMessageLog.Type}
 */
proto.proto.RoomMessageLog.prototype.getType = function() {
  return /** @type {!proto.proto.RoomMessageLog.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.RoomMessageLog.Type} value */
proto.proto.RoomMessageLog.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ExtraType extra_type = 2;
 * @return {!proto.proto.RoomMessageLog.ExtraType}
 */
proto.proto.RoomMessageLog.prototype.getExtraType = function() {
  return /** @type {!proto.proto.RoomMessageLog.ExtraType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.proto.RoomMessageLog.ExtraType} value */
proto.proto.RoomMessageLog.prototype.setExtraType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TargetUser target_user = 3;
 * @return {?proto.proto.RoomMessageLog.TargetUser}
 */
proto.proto.RoomMessageLog.prototype.getTargetUser = function() {
  return /** @type{?proto.proto.RoomMessageLog.TargetUser} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageLog.TargetUser, 3));
};


/** @param {?proto.proto.RoomMessageLog.TargetUser|undefined} value */
proto.proto.RoomMessageLog.prototype.setTargetUser = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.proto.RoomMessageLog.prototype.clearTargetUser = function() {
  this.setTargetUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageLog.prototype.hasTargetUser = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.RoomMessageContact.repeatedFields_, null);
};
goog.inherits(proto.proto.RoomMessageContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageContact.displayName = 'proto.proto.RoomMessageContact';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.RoomMessageContact.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageContact.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageContact.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phoneList: jspb.Message.getRepeatedField(msg, 4),
    emailList: jspb.Message.getRepeatedField(msg, 5)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageContact}
 */
proto.proto.RoomMessageContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageContact;
  return proto.proto.RoomMessageContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageContact}
 */
proto.proto.RoomMessageContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getEmailList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.proto.RoomMessageContact.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.RoomMessageContact.prototype.setFirstName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.proto.RoomMessageContact.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.RoomMessageContact.prototype.setLastName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.proto.RoomMessageContact.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.RoomMessageContact.prototype.setNickname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string phone = 4;
 * @return {!Array<string>}
 */
proto.proto.RoomMessageContact.prototype.getPhoneList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.proto.RoomMessageContact.prototype.setPhoneList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.proto.RoomMessageContact.prototype.addPhone = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.proto.RoomMessageContact.prototype.clearPhoneList = function() {
  this.setPhoneList([]);
};


/**
 * repeated string email = 5;
 * @return {!Array<string>}
 */
proto.proto.RoomMessageContact.prototype.getEmailList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.proto.RoomMessageContact.prototype.setEmailList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.proto.RoomMessageContact.prototype.addEmail = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


proto.proto.RoomMessageContact.prototype.clearEmailList = function() {
  this.setEmailList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageWallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageWallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageWallet.displayName = 'proto.proto.RoomMessageWallet';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageWallet.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageWallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageWallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    moneyTransfer: (f = msg.getMoneyTransfer()) && proto.proto.RoomMessageWallet.MoneyTransfer.toObject(includeInstance, f),
    cardToCard: (f = msg.getCardToCard()) && proto.proto.RoomMessageWallet.CardToCard.toObject(includeInstance, f),
    topup: (f = msg.getTopup()) && proto.proto.RoomMessageWallet.Topup.toObject(includeInstance, f),
    bill: (f = msg.getBill()) && proto.proto.RoomMessageWallet.Bill.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageWallet}
 */
proto.proto.RoomMessageWallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageWallet;
  return proto.proto.RoomMessageWallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageWallet}
 */
proto.proto.RoomMessageWallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.RoomMessageWallet.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.proto.RoomMessageWallet.MoneyTransfer;
      reader.readMessage(value,proto.proto.RoomMessageWallet.MoneyTransfer.deserializeBinaryFromReader);
      msg.setMoneyTransfer(value);
      break;
    case 3:
      var value = new proto.proto.RoomMessageWallet.CardToCard;
      reader.readMessage(value,proto.proto.RoomMessageWallet.CardToCard.deserializeBinaryFromReader);
      msg.setCardToCard(value);
      break;
    case 4:
      var value = new proto.proto.RoomMessageWallet.Topup;
      reader.readMessage(value,proto.proto.RoomMessageWallet.Topup.deserializeBinaryFromReader);
      msg.setTopup(value);
      break;
    case 5:
      var value = new proto.proto.RoomMessageWallet.Bill;
      reader.readMessage(value,proto.proto.RoomMessageWallet.Bill.deserializeBinaryFromReader);
      msg.setBill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageWallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageWallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMoneyTransfer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.RoomMessageWallet.MoneyTransfer.serializeBinaryToWriter
    );
  }
  f = message.getCardToCard();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.RoomMessageWallet.CardToCard.serializeBinaryToWriter
    );
  }
  f = message.getTopup();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.RoomMessageWallet.Topup.serializeBinaryToWriter
    );
  }
  f = message.getBill();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.RoomMessageWallet.Bill.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RoomMessageWallet.Type = {
  MONEY_TRANSFER: 0,
  PAYMENT: 1,
  CARD_TO_CARD: 2,
  TOPUP: 3,
  BILL: 4
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageWallet.MoneyTransfer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageWallet.MoneyTransfer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageWallet.MoneyTransfer.displayName = 'proto.proto.RoomMessageWallet.MoneyTransfer';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageWallet.MoneyTransfer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageWallet.MoneyTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.MoneyTransfer.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromUserId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    toUserId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    traceNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    invoiceNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    payTime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cardNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    rrn: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageWallet.MoneyTransfer}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageWallet.MoneyTransfer;
  return proto.proto.RoomMessageWallet.MoneyTransfer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageWallet.MoneyTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageWallet.MoneyTransfer}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setFromUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setToUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTraceNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvoiceNumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPayTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRrn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageWallet.MoneyTransfer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageWallet.MoneyTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.MoneyTransfer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getToUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getTraceNumber();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getInvoiceNumber();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPayTime();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRrn();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional uint64 from_user_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getFromUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setFromUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 to_user_id = 2;
 * @return {string}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getToUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setToUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 amount = 3;
 * @return {string}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 trace_number = 4;
 * @return {number}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getTraceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setTraceNumber = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 invoice_number = 5;
 * @return {number}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getInvoiceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setInvoiceNumber = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 pay_time = 6;
 * @return {number}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getPayTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setPayTime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string card_number = 8;
 * @return {string}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 rrn = 9;
 * @return {number}
 */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.getRrn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.MoneyTransfer.prototype.setRrn = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageWallet.CardToCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageWallet.CardToCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageWallet.CardToCard.displayName = 'proto.proto.RoomMessageWallet.CardToCard';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageWallet.CardToCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageWallet.CardToCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.CardToCard.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromUserId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    toUserId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    orderId: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    token: jspb.Message.getFieldWithDefault(msg, 4, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    sourceCardNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    destCardNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    requestTime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    rrn: jspb.Message.getFieldWithDefault(msg, 9, ""),
    traceNumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    bankname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    destbankname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cardownername: jspb.Message.getFieldWithDefault(msg, 13, ""),
    status: jspb.Message.getFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageWallet.CardToCard}
 */
proto.proto.RoomMessageWallet.CardToCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageWallet.CardToCard;
  return proto.proto.RoomMessageWallet.CardToCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageWallet.CardToCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageWallet.CardToCard}
 */
proto.proto.RoomMessageWallet.CardToCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setFromUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setToUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceCardNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestCardNumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRrn(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraceNumber(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestbankname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardownername(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageWallet.CardToCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageWallet.CardToCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.CardToCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getToUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getOrderId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getSourceCardNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDestCardNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRequestTime();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getRrn();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTraceNumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBankname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDestbankname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCardownername();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional uint64 from_user_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getFromUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setFromUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 to_user_id = 2;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getToUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setToUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 order_id = 3;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setOrderId = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string token = 4;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 amount = 5;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string source_card_number = 6;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getSourceCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setSourceCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string dest_card_number = 7;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getDestCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setDestCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 request_time = 8;
 * @return {number}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getRequestTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setRequestTime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string rrn = 9;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string trace_number = 10;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getTraceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setTraceNumber = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string bankName = 11;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getBankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setBankname = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string destBankName = 12;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getDestbankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setDestbankname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string cardOwnerName = 13;
 * @return {string}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getCardownername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setCardownername = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool status = 14;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomMessageWallet.CardToCard.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 14, false));
};


/** @param {boolean} value */
proto.proto.RoomMessageWallet.CardToCard.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 14, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageWallet.Topup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageWallet.Topup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageWallet.Topup.displayName = 'proto.proto.RoomMessageWallet.Topup';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageWallet.Topup.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageWallet.Topup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageWallet.Topup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.Topup.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromUserId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    myToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    token: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    requesterMobileNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    chargeMobileNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    topupType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    cardNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
    merchantName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    terminalNo: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 12, "0"),
    traceNumber: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    requestTime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    status: jspb.Message.getFieldWithDefault(msg, 15, false),
    statusDescription: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageWallet.Topup}
 */
proto.proto.RoomMessageWallet.Topup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageWallet.Topup;
  return proto.proto.RoomMessageWallet.Topup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageWallet.Topup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageWallet.Topup}
 */
proto.proto.RoomMessageWallet.Topup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setFromUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMyToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequesterMobileNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeMobileNumber(value);
      break;
    case 8:
      var value = /** @type {!proto.proto.RoomMessageWallet.Topup.Type} */ (reader.readEnum());
      msg.setTopupType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTerminalNo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTraceNumber(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestTime(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageWallet.Topup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageWallet.Topup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageWallet.Topup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.Topup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getOrderId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMyToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToken();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getRequesterMobileNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getChargeMobileNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTopupType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMerchantName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTerminalNo();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      11,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      12,
      f
    );
  }
  f = message.getTraceNumber();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      13,
      f
    );
  }
  f = message.getRequestTime();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getStatusDescription();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RoomMessageWallet.Topup.Type = {
  IRANCELL_PREPAID: 0,
  IRANCELL_WOW: 1,
  IRANCELL_WIMAX: 2,
  IRANCELL_POSTPAID: 3,
  MCI: 4,
  RIGHTEL: 5
};

/**
 * optional uint64 from_user_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getFromUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setFromUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 order_id = 2;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setOrderId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string my_token = 3;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getMyToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setMyToken = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 token = 4;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setToken = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional uint64 amount = 5;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string requester_mobile_number = 6;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getRequesterMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setRequesterMobileNumber = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string charge_mobile_number = 7;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getChargeMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setChargeMobileNumber = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Type topup_type = 8;
 * @return {!proto.proto.RoomMessageWallet.Topup.Type}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getTopupType = function() {
  return /** @type {!proto.proto.RoomMessageWallet.Topup.Type} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.proto.RoomMessageWallet.Topup.Type} value */
proto.proto.RoomMessageWallet.Topup.prototype.setTopupType = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string card_number = 9;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string merchant_name = 10;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getMerchantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setMerchantName = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional uint64 terminal_no = 11;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getTerminalNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setTerminalNo = function(value) {
  jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional uint64 rrn = 12;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 12, value);
};


/**
 * optional uint64 trace_number = 13;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getTraceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setTraceNumber = function(value) {
  jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional uint32 request_time = 14;
 * @return {number}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getRequestTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.Topup.prototype.setRequestTime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool status = 15;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 15, false));
};


/** @param {boolean} value */
proto.proto.RoomMessageWallet.Topup.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string status_description = 16;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Topup.prototype.getStatusDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Topup.prototype.setStatusDescription = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageWallet.Bill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageWallet.Bill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageWallet.Bill.displayName = 'proto.proto.RoomMessageWallet.Bill';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageWallet.Bill.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageWallet.Bill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageWallet.Bill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.Bill.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromUserId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    myToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    token: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    payId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    billId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    billType: jspb.Message.getFieldWithDefault(msg, 8, ""),
    cardNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
    merchantName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    terminalNo: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 12, "0"),
    traceNumber: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    requestTime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    status: jspb.Message.getFieldWithDefault(msg, 15, false),
    statusDescription: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageWallet.Bill}
 */
proto.proto.RoomMessageWallet.Bill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageWallet.Bill;
  return proto.proto.RoomMessageWallet.Bill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageWallet.Bill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageWallet.Bill}
 */
proto.proto.RoomMessageWallet.Bill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setFromUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMyToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTerminalNo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTraceNumber(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestTime(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageWallet.Bill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageWallet.Bill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageWallet.Bill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageWallet.Bill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getOrderId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMyToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToken();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getPayId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBillId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBillType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMerchantName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTerminalNo();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      11,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      12,
      f
    );
  }
  f = message.getTraceNumber();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      13,
      f
    );
  }
  f = message.getRequestTime();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getStatusDescription();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional uint64 from_user_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getFromUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setFromUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 order_id = 2;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setOrderId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string my_token = 3;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getMyToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setMyToken = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 token = 4;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setToken = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional uint64 amount = 5;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string pay_id = 6;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getPayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setPayId = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string bill_id = 7;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getBillId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setBillId = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string bill_type = 8;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getBillType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setBillType = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string card_number = 9;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string merchant_name = 10;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getMerchantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setMerchantName = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional uint64 terminal_no = 11;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getTerminalNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setTerminalNo = function(value) {
  jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional uint64 rrn = 12;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 12, value);
};


/**
 * optional uint64 trace_number = 13;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getTraceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setTraceNumber = function(value) {
  jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional uint32 request_time = 14;
 * @return {number}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getRequestTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.proto.RoomMessageWallet.Bill.prototype.setRequestTime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool status = 15;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 15, false));
};


/** @param {boolean} value */
proto.proto.RoomMessageWallet.Bill.prototype.setStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string status_description = 16;
 * @return {string}
 */
proto.proto.RoomMessageWallet.Bill.prototype.getStatusDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.proto.RoomMessageWallet.Bill.prototype.setStatusDescription = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional Type type = 1;
 * @return {!proto.proto.RoomMessageWallet.Type}
 */
proto.proto.RoomMessageWallet.prototype.getType = function() {
  return /** @type {!proto.proto.RoomMessageWallet.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.RoomMessageWallet.Type} value */
proto.proto.RoomMessageWallet.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional MoneyTransfer money_transfer = 2;
 * @return {?proto.proto.RoomMessageWallet.MoneyTransfer}
 */
proto.proto.RoomMessageWallet.prototype.getMoneyTransfer = function() {
  return /** @type{?proto.proto.RoomMessageWallet.MoneyTransfer} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageWallet.MoneyTransfer, 2));
};


/** @param {?proto.proto.RoomMessageWallet.MoneyTransfer|undefined} value */
proto.proto.RoomMessageWallet.prototype.setMoneyTransfer = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proto.RoomMessageWallet.prototype.clearMoneyTransfer = function() {
  this.setMoneyTransfer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageWallet.prototype.hasMoneyTransfer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CardToCard card_to_card = 3;
 * @return {?proto.proto.RoomMessageWallet.CardToCard}
 */
proto.proto.RoomMessageWallet.prototype.getCardToCard = function() {
  return /** @type{?proto.proto.RoomMessageWallet.CardToCard} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageWallet.CardToCard, 3));
};


/** @param {?proto.proto.RoomMessageWallet.CardToCard|undefined} value */
proto.proto.RoomMessageWallet.prototype.setCardToCard = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.proto.RoomMessageWallet.prototype.clearCardToCard = function() {
  this.setCardToCard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageWallet.prototype.hasCardToCard = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Topup topup = 4;
 * @return {?proto.proto.RoomMessageWallet.Topup}
 */
proto.proto.RoomMessageWallet.prototype.getTopup = function() {
  return /** @type{?proto.proto.RoomMessageWallet.Topup} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageWallet.Topup, 4));
};


/** @param {?proto.proto.RoomMessageWallet.Topup|undefined} value */
proto.proto.RoomMessageWallet.prototype.setTopup = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.proto.RoomMessageWallet.prototype.clearTopup = function() {
  this.setTopup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageWallet.prototype.hasTopup = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Bill bill = 5;
 * @return {?proto.proto.RoomMessageWallet.Bill}
 */
proto.proto.RoomMessageWallet.prototype.getBill = function() {
  return /** @type{?proto.proto.RoomMessageWallet.Bill} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageWallet.Bill, 5));
};


/** @param {?proto.proto.RoomMessageWallet.Bill|undefined} value */
proto.proto.RoomMessageWallet.prototype.setBill = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.proto.RoomMessageWallet.prototype.clearBill = function() {
  this.setBill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageWallet.prototype.hasBill = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageForwardFrom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageForwardFrom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageForwardFrom.displayName = 'proto.proto.RoomMessageForwardFrom';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageForwardFrom.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageForwardFrom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageForwardFrom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageForwardFrom.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    messageId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    documentId: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageForwardFrom}
 */
proto.proto.RoomMessageForwardFrom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageForwardFrom;
  return proto.proto.RoomMessageForwardFrom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageForwardFrom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageForwardFrom}
 */
proto.proto.RoomMessageForwardFrom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRoomId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMessageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageForwardFrom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageForwardFrom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageForwardFrom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageForwardFrom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getMessageId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getDocumentId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
};


/**
 * optional uint64 room_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageForwardFrom.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageForwardFrom.prototype.setRoomId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 message_id = 2;
 * @return {string}
 */
proto.proto.RoomMessageForwardFrom.prototype.getMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageForwardFrom.prototype.setMessageId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 document_id = 3;
 * @return {string}
 */
proto.proto.RoomMessageForwardFrom.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageForwardFrom.prototype.setDocumentId = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageStory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageStory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageStory.displayName = 'proto.proto.RoomMessageStory';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageStory.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageStory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageStory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStory.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    story: (f = msg.getStory()) && proto.proto.Story.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageStory}
 */
proto.proto.RoomMessageStory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageStory;
  return proto.proto.RoomMessageStory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageStory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageStory}
 */
proto.proto.RoomMessageStory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.RoomMessageStory.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.proto.Story;
      reader.readMessage(value,proto.proto.Story.deserializeBinaryFromReader);
      msg.setStory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageStory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageStory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageStory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStory();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Story.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RoomMessageStory.Status = {
  ACTIVE: 0,
  EXPIRED: 1,
  PRIVATE: 2,
  DELETED: 3
};

/**
 * optional Status status = 1;
 * @return {!proto.proto.RoomMessageStory.Status}
 */
proto.proto.RoomMessageStory.prototype.getStatus = function() {
  return /** @type {!proto.proto.RoomMessageStory.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.RoomMessageStory.Status} value */
proto.proto.RoomMessageStory.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Story story = 2;
 * @return {?proto.proto.Story}
 */
proto.proto.RoomMessageStory.prototype.getStory = function() {
  return /** @type{?proto.proto.Story} */ (
    jspb.Message.getWrapperField(this, proto.proto.Story, 2));
};


/** @param {?proto.proto.Story|undefined} value */
proto.proto.RoomMessageStory.prototype.setStory = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proto.RoomMessageStory.prototype.clearStory = function() {
  this.setStory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessageStory.prototype.hasStory = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageStoryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageStoryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageStoryReply.displayName = 'proto.proto.RoomMessageStoryReply';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageStoryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageStoryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageStoryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStoryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    storyId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    caption: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageStoryReply}
 */
proto.proto.RoomMessageStoryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageStoryReply;
  return proto.proto.RoomMessageStoryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageStoryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageStoryReply}
 */
proto.proto.RoomMessageStoryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setStoryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageStoryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageStoryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageStoryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStoryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoryId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 story_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageStoryReply.prototype.getStoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageStoryReply.prototype.setStoryId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.proto.RoomMessageStoryReply.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.RoomMessageStoryReply.prototype.setCaption = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessageStoryForward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessageStoryForward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessageStoryForward.displayName = 'proto.proto.RoomMessageStoryForward';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessageStoryForward.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessageStoryForward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessageStoryForward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStoryForward.toObject = function(includeInstance, msg) {
  var f, obj = {
    storyId: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessageStoryForward}
 */
proto.proto.RoomMessageStoryForward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessageStoryForward;
  return proto.proto.RoomMessageStoryForward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessageStoryForward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessageStoryForward}
 */
proto.proto.RoomMessageStoryForward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setStoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessageStoryForward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessageStoryForward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessageStoryForward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessageStoryForward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoryId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 story_id = 1;
 * @return {string}
 */
proto.proto.RoomMessageStoryForward.prototype.getStoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessageStoryForward.prototype.setStoryId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Story = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Story, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Story.displayName = 'proto.proto.Story';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Story.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Story.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Story} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Story.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    fileToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileDetails: (f = msg.getFileDetails()) && proto.proto.File.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    roomId: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    caption: jspb.Message.getFieldWithDefault(msg, 7, ""),
    link: jspb.Message.getFieldWithDefault(msg, 8, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
    endAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
    seen: jspb.Message.getFieldWithDefault(msg, 11, false),
    duplicated: jspb.Message.getFieldWithDefault(msg, 12, false),
    originator: jspb.Message.getFieldWithDefault(msg, 13, 0),
    views: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Story}
 */
proto.proto.Story.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Story;
  return proto.proto.Story.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Story} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Story}
 */
proto.proto.Story.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileToken(value);
      break;
    case 3:
      var value = new proto.proto.File;
      reader.readMessage(value,proto.proto.File.deserializeBinaryFromReader);
      msg.setFileDetails(value);
      break;
    case 4:
      var value = /** @type {!proto.proto.Story.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRoomId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEndAt(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSeen(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDuplicated(value);
      break;
    case 13:
      var value = /** @type {!proto.proto.Originator} */ (reader.readEnum());
      msg.setOriginator(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setViews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Story.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Story.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Story} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Story.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getFileToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.File.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getRoomId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getSeen();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getDuplicated();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getOriginator();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getViews();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.Story.Type = {
  STORY: 0,
  LIVE: 1
};

/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.proto.Story.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.Story.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string file_token = 2;
 * @return {string}
 */
proto.proto.Story.prototype.getFileToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.Story.prototype.setFileToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional File file_details = 3;
 * @return {?proto.proto.File}
 */
proto.proto.Story.prototype.getFileDetails = function() {
  return /** @type{?proto.proto.File} */ (
    jspb.Message.getWrapperField(this, proto.proto.File, 3));
};


/** @param {?proto.proto.File|undefined} value */
proto.proto.Story.prototype.setFileDetails = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.proto.Story.prototype.clearFileDetails = function() {
  this.setFileDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Story.prototype.hasFileDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Type type = 4;
 * @return {!proto.proto.Story.Type}
 */
proto.proto.Story.prototype.getType = function() {
  return /** @type {!proto.proto.Story.Type} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.proto.Story.Type} value */
proto.proto.Story.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional uint64 user_id = 5;
 * @return {string}
 */
proto.proto.Story.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.Story.prototype.setUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 room_id = 6;
 * @return {string}
 */
proto.proto.Story.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.proto.Story.prototype.setRoomId = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string caption = 7;
 * @return {string}
 */
proto.proto.Story.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.Story.prototype.setCaption = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string link = 8;
 * @return {string}
 */
proto.proto.Story.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.proto.Story.prototype.setLink = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 created_at = 9;
 * @return {number}
 */
proto.proto.Story.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.proto.Story.prototype.setCreatedAt = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 end_at = 10;
 * @return {number}
 */
proto.proto.Story.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.proto.Story.prototype.setEndAt = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool seen = 11;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.Story.prototype.getSeen = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 11, false));
};


/** @param {boolean} value */
proto.proto.Story.prototype.setSeen = function(value) {
  jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool duplicated = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.Story.prototype.getDuplicated = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.proto.Story.prototype.setDuplicated = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional Originator originator = 13;
 * @return {!proto.proto.Originator}
 */
proto.proto.Story.prototype.getOriginator = function() {
  return /** @type {!proto.proto.Originator} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.proto.Originator} value */
proto.proto.Story.prototype.setOriginator = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional uint32 views = 14;
 * @return {number}
 */
proto.proto.Story.prototype.getViews = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.proto.Story.prototype.setViews = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RegisteredUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RegisteredUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RegisteredUser.displayName = 'proto.proto.RegisteredUser';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RegisteredUser.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RegisteredUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RegisteredUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RegisteredUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    firstName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    initials: jspb.Message.getFieldWithDefault(msg, 7, ""),
    color: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    lastSeen: jspb.Message.getFieldWithDefault(msg, 10, 0),
    avatarCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    avatar: (f = msg.getAvatar()) && proto.proto.Avatar.toObject(includeInstance, f),
    mutual: jspb.Message.getFieldWithDefault(msg, 13, false),
    deleted: jspb.Message.getFieldWithDefault(msg, 14, false),
    cacheId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    bio: jspb.Message.getFieldWithDefault(msg, 16, ""),
    verified: jspb.Message.getFieldWithDefault(msg, 17, false),
    bot: jspb.Message.getFieldWithDefault(msg, 18, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RegisteredUser}
 */
proto.proto.RegisteredUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RegisteredUser;
  return proto.proto.RegisteredUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RegisteredUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RegisteredUser}
 */
proto.proto.RegisteredUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInitials(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 9:
      var value = /** @type {!proto.proto.RegisteredUser.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLastSeen(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvatarCount(value);
      break;
    case 12:
      var value = new proto.proto.Avatar;
      reader.readMessage(value,proto.proto.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMutual(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCacheId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBio(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RegisteredUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RegisteredUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RegisteredUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RegisteredUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInitials();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getLastSeen();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getAvatarCount();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.proto.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getMutual();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCacheId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBio();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getBot();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RegisteredUser.Status = {
  LONG_TIME_AGO: 0,
  LAST_MONTH: 1,
  LAST_WEEK: 2,
  ONLINE: 3,
  EXACTLY: 4,
  RECENTLY: 5,
  SUPPORT: 6,
  SERVICE_NOTIFICATIONS: 7
};

/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 phone = 3;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string first_name = 4;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setFirstName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_name = 5;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setLastName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string display_name = 6;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string initials = 7;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getInitials = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setInitials = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string color = 8;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setColor = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Status status = 9;
 * @return {!proto.proto.RegisteredUser.Status}
 */
proto.proto.RegisteredUser.prototype.getStatus = function() {
  return /** @type {!proto.proto.RegisteredUser.Status} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.proto.RegisteredUser.Status} value */
proto.proto.RegisteredUser.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional uint32 last_seen = 10;
 * @return {number}
 */
proto.proto.RegisteredUser.prototype.getLastSeen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.proto.RegisteredUser.prototype.setLastSeen = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 avatar_count = 11;
 * @return {number}
 */
proto.proto.RegisteredUser.prototype.getAvatarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.proto.RegisteredUser.prototype.setAvatarCount = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Avatar avatar = 12;
 * @return {?proto.proto.Avatar}
 */
proto.proto.RegisteredUser.prototype.getAvatar = function() {
  return /** @type{?proto.proto.Avatar} */ (
    jspb.Message.getWrapperField(this, proto.proto.Avatar, 12));
};


/** @param {?proto.proto.Avatar|undefined} value */
proto.proto.RegisteredUser.prototype.setAvatar = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


proto.proto.RegisteredUser.prototype.clearAvatar = function() {
  this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RegisteredUser.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool mutual = 13;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RegisteredUser.prototype.getMutual = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 13, false));
};


/** @param {boolean} value */
proto.proto.RegisteredUser.prototype.setMutual = function(value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool deleted = 14;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RegisteredUser.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 14, false));
};


/** @param {boolean} value */
proto.proto.RegisteredUser.prototype.setDeleted = function(value) {
  jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string cache_id = 15;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getCacheId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setCacheId = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string bio = 16;
 * @return {string}
 */
proto.proto.RegisteredUser.prototype.getBio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.proto.RegisteredUser.prototype.setBio = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool verified = 17;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RegisteredUser.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 17, false));
};


/** @param {boolean} value */
proto.proto.RegisteredUser.prototype.setVerified = function(value) {
  jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool bot = 18;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RegisteredUser.prototype.getBot = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 18, false));
};


/** @param {boolean} value */
proto.proto.RegisteredUser.prototype.setBot = function(value) {
  jspb.Message.setProto3BooleanField(this, 18, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Avatar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Avatar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Avatar.displayName = 'proto.proto.Avatar';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Avatar.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Avatar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Avatar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Avatar.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    file: (f = msg.getFile()) && proto.proto.File.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Avatar}
 */
proto.proto.Avatar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Avatar;
  return proto.proto.Avatar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Avatar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Avatar}
 */
proto.proto.Avatar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.proto.File;
      reader.readMessage(value,proto.proto.File.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Avatar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Avatar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Avatar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Avatar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.File.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.proto.Avatar.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.Avatar.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional File file = 2;
 * @return {?proto.proto.File}
 */
proto.proto.Avatar.prototype.getFile = function() {
  return /** @type{?proto.proto.File} */ (
    jspb.Message.getWrapperField(this, proto.proto.File, 2));
};


/** @param {?proto.proto.File|undefined} value */
proto.proto.Avatar.prototype.setFile = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proto.Avatar.prototype.clearFile = function() {
  this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Avatar.prototype.hasFile = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessage.displayName = 'proto.proto.RoomMessage';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 26, "0"),
    messageId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    messageVersion: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    statusVersion: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    messageType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    message: jspb.Message.getFieldWithDefault(msg, 6, ""),
    attachment: (f = msg.getAttachment()) && proto.proto.File.toObject(includeInstance, f),
    author: (f = msg.getAuthor()) && proto.proto.RoomMessage.Author.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && proto.proto.RoomMessageLocation.toObject(includeInstance, f),
    log: (f = msg.getLog()) && proto.proto.RoomMessageLog.toObject(includeInstance, f),
    contact: (f = msg.getContact()) && proto.proto.RoomMessageContact.toObject(includeInstance, f),
    wallet: (f = msg.getWallet()) && proto.proto.RoomMessageWallet.toObject(includeInstance, f),
    edited: jspb.Message.getFieldWithDefault(msg, 12, false),
    createTime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    updateTime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    deleted: jspb.Message.getFieldWithDefault(msg, 15, false),
    forwardFrom: (f = msg.getForwardFrom()) && proto.proto.RoomMessage.toObject(includeInstance, f),
    replyTo: (f = msg.getReplyTo()) && proto.proto.RoomMessage.toObject(includeInstance, f),
    story: (f = msg.getStory()) && proto.proto.RoomMessageStory.toObject(includeInstance, f),
    previousMessageId: jspb.Message.getFieldWithDefault(msg, 18, "0"),
    randomId: jspb.Message.getFieldWithDefault(msg, 21, "0"),
    additionalType: jspb.Message.getFieldWithDefault(msg, 23, 0),
    additionalData: jspb.Message.getFieldWithDefault(msg, 24, ""),
    extraType: jspb.Message.getFieldWithDefault(msg, 19, 0),
    channelExtra: (f = msg.getChannelExtra()) && proto.proto.RoomMessage.ChannelExtra.toObject(includeInstance, f),
    documentId: jspb.Message.getFieldWithDefault(msg, 27, "0"),
    versionDocumentId: jspb.Message.getFieldWithDefault(msg, 28, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessage}
 */
proto.proto.RoomMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessage;
  return proto.proto.RoomMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessage}
 */
proto.proto.RoomMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 26:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRoomId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMessageId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMessageVersion(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.RoomMessageStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setStatusVersion(value);
      break;
    case 5:
      var value = /** @type {!proto.proto.RoomMessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 7:
      var value = new proto.proto.File;
      reader.readMessage(value,proto.proto.File.deserializeBinaryFromReader);
      msg.setAttachment(value);
      break;
    case 8:
      var value = new proto.proto.RoomMessage.Author;
      reader.readMessage(value,proto.proto.RoomMessage.Author.deserializeBinaryFromReader);
      msg.setAuthor(value);
      break;
    case 9:
      var value = new proto.proto.RoomMessageLocation;
      reader.readMessage(value,proto.proto.RoomMessageLocation.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 10:
      var value = new proto.proto.RoomMessageLog;
      reader.readMessage(value,proto.proto.RoomMessageLog.deserializeBinaryFromReader);
      msg.setLog(value);
      break;
    case 11:
      var value = new proto.proto.RoomMessageContact;
      reader.readMessage(value,proto.proto.RoomMessageContact.deserializeBinaryFromReader);
      msg.setContact(value);
      break;
    case 22:
      var value = new proto.proto.RoomMessageWallet;
      reader.readMessage(value,proto.proto.RoomMessageWallet.deserializeBinaryFromReader);
      msg.setWallet(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEdited(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreateTime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUpdateTime(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 16:
      var value = new proto.proto.RoomMessage;
      reader.readMessage(value,proto.proto.RoomMessage.deserializeBinaryFromReader);
      msg.setForwardFrom(value);
      break;
    case 17:
      var value = new proto.proto.RoomMessage;
      reader.readMessage(value,proto.proto.RoomMessage.deserializeBinaryFromReader);
      msg.setReplyTo(value);
      break;
    case 25:
      var value = new proto.proto.RoomMessageStory;
      reader.readMessage(value,proto.proto.RoomMessageStory.deserializeBinaryFromReader);
      msg.setStory(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setPreviousMessageId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRandomId(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAdditionalType(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionalData(value);
      break;
    case 19:
      var value = /** @type {!proto.proto.RoomMessage.ExtraType} */ (reader.readEnum());
      msg.setExtraType(value);
      break;
    case 20:
      var value = new proto.proto.RoomMessage.ChannelExtra;
      reader.readMessage(value,proto.proto.RoomMessage.ChannelExtra.deserializeBinaryFromReader);
      msg.setChannelExtra(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setDocumentId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setVersionDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      26,
      f
    );
  }
  f = message.getMessageId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getMessageVersion();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatusVersion();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAttachment();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.File.serializeBinaryToWriter
    );
  }
  f = message.getAuthor();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.RoomMessage.Author.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.proto.RoomMessageLocation.serializeBinaryToWriter
    );
  }
  f = message.getLog();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.proto.RoomMessageLog.serializeBinaryToWriter
    );
  }
  f = message.getContact();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.proto.RoomMessageContact.serializeBinaryToWriter
    );
  }
  f = message.getWallet();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.proto.RoomMessageWallet.serializeBinaryToWriter
    );
  }
  f = message.getEdited();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getCreateTime();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getUpdateTime();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getForwardFrom();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.proto.RoomMessage.serializeBinaryToWriter
    );
  }
  f = message.getReplyTo();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.proto.RoomMessage.serializeBinaryToWriter
    );
  }
  f = message.getStory();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.proto.RoomMessageStory.serializeBinaryToWriter
    );
  }
  f = message.getPreviousMessageId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      18,
      f
    );
  }
  f = message.getRandomId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      21,
      f
    );
  }
  f = message.getAdditionalType();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getAdditionalData();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getExtraType();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getChannelExtra();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.proto.RoomMessage.ChannelExtra.serializeBinaryToWriter
    );
  }
  f = message.getDocumentId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      27,
      f
    );
  }
  f = message.getVersionDocumentId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      28,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.RoomMessage.ExtraType = {
  NO_EXTRA: 0,
  CHANNEL_EXTRA: 1
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessage.Author = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessage.Author, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessage.Author.displayName = 'proto.proto.RoomMessage.Author';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessage.Author.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessage.Author.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessage.Author} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    user: (f = msg.getUser()) && proto.proto.RoomMessage.Author.User.toObject(includeInstance, f),
    room: (f = msg.getRoom()) && proto.proto.RoomMessage.Author.Room.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessage.Author}
 */
proto.proto.RoomMessage.Author.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessage.Author;
  return proto.proto.RoomMessage.Author.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessage.Author} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessage.Author}
 */
proto.proto.RoomMessage.Author.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = new proto.proto.RoomMessage.Author.User;
      reader.readMessage(value,proto.proto.RoomMessage.Author.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.proto.RoomMessage.Author.Room;
      reader.readMessage(value,proto.proto.RoomMessage.Author.Room.deserializeBinaryFromReader);
      msg.setRoom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessage.Author.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessage.Author.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessage.Author} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.RoomMessage.Author.User.serializeBinaryToWriter
    );
  }
  f = message.getRoom();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.RoomMessage.Author.Room.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessage.Author.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessage.Author.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessage.Author.User.displayName = 'proto.proto.RoomMessage.Author.User';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessage.Author.User.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessage.Author.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessage.Author.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    cacheId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessage.Author.User}
 */
proto.proto.RoomMessage.Author.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessage.Author.User;
  return proto.proto.RoomMessage.Author.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessage.Author.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessage.Author.User}
 */
proto.proto.RoomMessage.Author.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCacheId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessage.Author.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessage.Author.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessage.Author.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getCacheId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 user_id = 1;
 * @return {string}
 */
proto.proto.RoomMessage.Author.User.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.Author.User.prototype.setUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string cache_id = 2;
 * @return {string}
 */
proto.proto.RoomMessage.Author.User.prototype.getCacheId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.Author.User.prototype.setCacheId = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessage.Author.Room = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessage.Author.Room, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessage.Author.Room.displayName = 'proto.proto.RoomMessage.Author.Room';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessage.Author.Room.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessage.Author.Room.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessage.Author.Room} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.Room.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessage.Author.Room}
 */
proto.proto.RoomMessage.Author.Room.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessage.Author.Room;
  return proto.proto.RoomMessage.Author.Room.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessage.Author.Room} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessage.Author.Room}
 */
proto.proto.RoomMessage.Author.Room.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRoomId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessage.Author.Room.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessage.Author.Room.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessage.Author.Room} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.Author.Room.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 room_id = 1;
 * @return {string}
 */
proto.proto.RoomMessage.Author.Room.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.Author.Room.prototype.setRoomId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.proto.RoomMessage.Author.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.Author.prototype.setHash = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional User user = 2;
 * @return {?proto.proto.RoomMessage.Author.User}
 */
proto.proto.RoomMessage.Author.prototype.getUser = function() {
  return /** @type{?proto.proto.RoomMessage.Author.User} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage.Author.User, 2));
};


/** @param {?proto.proto.RoomMessage.Author.User|undefined} value */
proto.proto.RoomMessage.Author.prototype.setUser = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proto.RoomMessage.Author.prototype.clearUser = function() {
  this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.Author.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Room room = 3;
 * @return {?proto.proto.RoomMessage.Author.Room}
 */
proto.proto.RoomMessage.Author.prototype.getRoom = function() {
  return /** @type{?proto.proto.RoomMessage.Author.Room} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage.Author.Room, 3));
};


/** @param {?proto.proto.RoomMessage.Author.Room|undefined} value */
proto.proto.RoomMessage.Author.prototype.setRoom = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.proto.RoomMessage.Author.prototype.clearRoom = function() {
  this.setRoom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.Author.prototype.hasRoom = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomMessage.ChannelExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomMessage.ChannelExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomMessage.ChannelExtra.displayName = 'proto.proto.RoomMessage.ChannelExtra';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomMessage.ChannelExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomMessage.ChannelExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.ChannelExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    signature: jspb.Message.getFieldWithDefault(msg, 1, ""),
    viewsLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    thumbsUpLabel: jspb.Message.getFieldWithDefault(msg, 3, ""),
    thumbsDownLabel: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomMessage.ChannelExtra}
 */
proto.proto.RoomMessage.ChannelExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomMessage.ChannelExtra;
  return proto.proto.RoomMessage.ChannelExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomMessage.ChannelExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomMessage.ChannelExtra}
 */
proto.proto.RoomMessage.ChannelExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setViewsLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbsUpLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbsDownLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomMessage.ChannelExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomMessage.ChannelExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomMessage.ChannelExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getViewsLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThumbsUpLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getThumbsDownLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string signature = 1;
 * @return {string}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.ChannelExtra.prototype.setSignature = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string views_label = 2;
 * @return {string}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.getViewsLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.ChannelExtra.prototype.setViewsLabel = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string thumbs_up_label = 3;
 * @return {string}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.getThumbsUpLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.ChannelExtra.prototype.setThumbsUpLabel = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string thumbs_down_label = 4;
 * @return {string}
 */
proto.proto.RoomMessage.ChannelExtra.prototype.getThumbsDownLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.ChannelExtra.prototype.setThumbsDownLabel = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 room_id = 26;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setRoomId = function(value) {
  jspb.Message.setProto3StringIntField(this, 26, value);
};


/**
 * optional uint64 message_id = 1;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setMessageId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 message_version = 2;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getMessageVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setMessageVersion = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional RoomMessageStatus status = 3;
 * @return {!proto.proto.RoomMessageStatus}
 */
proto.proto.RoomMessage.prototype.getStatus = function() {
  return /** @type {!proto.proto.RoomMessageStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.proto.RoomMessageStatus} value */
proto.proto.RoomMessage.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint64 status_version = 4;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getStatusVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setStatusVersion = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional RoomMessageType message_type = 5;
 * @return {!proto.proto.RoomMessageType}
 */
proto.proto.RoomMessage.prototype.getMessageType = function() {
  return /** @type {!proto.proto.RoomMessageType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.proto.RoomMessageType} value */
proto.proto.RoomMessage.prototype.setMessageType = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string message = 6;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional File attachment = 7;
 * @return {?proto.proto.File}
 */
proto.proto.RoomMessage.prototype.getAttachment = function() {
  return /** @type{?proto.proto.File} */ (
    jspb.Message.getWrapperField(this, proto.proto.File, 7));
};


/** @param {?proto.proto.File|undefined} value */
proto.proto.RoomMessage.prototype.setAttachment = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.proto.RoomMessage.prototype.clearAttachment = function() {
  this.setAttachment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasAttachment = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Author author = 8;
 * @return {?proto.proto.RoomMessage.Author}
 */
proto.proto.RoomMessage.prototype.getAuthor = function() {
  return /** @type{?proto.proto.RoomMessage.Author} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage.Author, 8));
};


/** @param {?proto.proto.RoomMessage.Author|undefined} value */
proto.proto.RoomMessage.prototype.setAuthor = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.proto.RoomMessage.prototype.clearAuthor = function() {
  this.setAuthor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasAuthor = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional RoomMessageLocation location = 9;
 * @return {?proto.proto.RoomMessageLocation}
 */
proto.proto.RoomMessage.prototype.getLocation = function() {
  return /** @type{?proto.proto.RoomMessageLocation} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageLocation, 9));
};


/** @param {?proto.proto.RoomMessageLocation|undefined} value */
proto.proto.RoomMessage.prototype.setLocation = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.proto.RoomMessage.prototype.clearLocation = function() {
  this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional RoomMessageLog log = 10;
 * @return {?proto.proto.RoomMessageLog}
 */
proto.proto.RoomMessage.prototype.getLog = function() {
  return /** @type{?proto.proto.RoomMessageLog} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageLog, 10));
};


/** @param {?proto.proto.RoomMessageLog|undefined} value */
proto.proto.RoomMessage.prototype.setLog = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.proto.RoomMessage.prototype.clearLog = function() {
  this.setLog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasLog = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional RoomMessageContact contact = 11;
 * @return {?proto.proto.RoomMessageContact}
 */
proto.proto.RoomMessage.prototype.getContact = function() {
  return /** @type{?proto.proto.RoomMessageContact} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageContact, 11));
};


/** @param {?proto.proto.RoomMessageContact|undefined} value */
proto.proto.RoomMessage.prototype.setContact = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.proto.RoomMessage.prototype.clearContact = function() {
  this.setContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasContact = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional RoomMessageWallet wallet = 22;
 * @return {?proto.proto.RoomMessageWallet}
 */
proto.proto.RoomMessage.prototype.getWallet = function() {
  return /** @type{?proto.proto.RoomMessageWallet} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageWallet, 22));
};


/** @param {?proto.proto.RoomMessageWallet|undefined} value */
proto.proto.RoomMessage.prototype.setWallet = function(value) {
  jspb.Message.setWrapperField(this, 22, value);
};


proto.proto.RoomMessage.prototype.clearWallet = function() {
  this.setWallet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasWallet = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool edited = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomMessage.prototype.getEdited = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.proto.RoomMessage.prototype.setEdited = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional uint32 create_time = 13;
 * @return {number}
 */
proto.proto.RoomMessage.prototype.getCreateTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.proto.RoomMessage.prototype.setCreateTime = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint32 update_time = 14;
 * @return {number}
 */
proto.proto.RoomMessage.prototype.getUpdateTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.proto.RoomMessage.prototype.setUpdateTime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool deleted = 15;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomMessage.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 15, false));
};


/** @param {boolean} value */
proto.proto.RoomMessage.prototype.setDeleted = function(value) {
  jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional RoomMessage forward_from = 16;
 * @return {?proto.proto.RoomMessage}
 */
proto.proto.RoomMessage.prototype.getForwardFrom = function() {
  return /** @type{?proto.proto.RoomMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage, 16));
};


/** @param {?proto.proto.RoomMessage|undefined} value */
proto.proto.RoomMessage.prototype.setForwardFrom = function(value) {
  jspb.Message.setWrapperField(this, 16, value);
};


proto.proto.RoomMessage.prototype.clearForwardFrom = function() {
  this.setForwardFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasForwardFrom = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional RoomMessage reply_to = 17;
 * @return {?proto.proto.RoomMessage}
 */
proto.proto.RoomMessage.prototype.getReplyTo = function() {
  return /** @type{?proto.proto.RoomMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage, 17));
};


/** @param {?proto.proto.RoomMessage|undefined} value */
proto.proto.RoomMessage.prototype.setReplyTo = function(value) {
  jspb.Message.setWrapperField(this, 17, value);
};


proto.proto.RoomMessage.prototype.clearReplyTo = function() {
  this.setReplyTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasReplyTo = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional RoomMessageStory story = 25;
 * @return {?proto.proto.RoomMessageStory}
 */
proto.proto.RoomMessage.prototype.getStory = function() {
  return /** @type{?proto.proto.RoomMessageStory} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessageStory, 25));
};


/** @param {?proto.proto.RoomMessageStory|undefined} value */
proto.proto.RoomMessage.prototype.setStory = function(value) {
  jspb.Message.setWrapperField(this, 25, value);
};


proto.proto.RoomMessage.prototype.clearStory = function() {
  this.setStory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasStory = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional uint64 previous_message_id = 18;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getPreviousMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setPreviousMessageId = function(value) {
  jspb.Message.setProto3StringIntField(this, 18, value);
};


/**
 * optional uint64 random_id = 21;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getRandomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setRandomId = function(value) {
  jspb.Message.setProto3StringIntField(this, 21, value);
};


/**
 * optional uint32 additional_type = 23;
 * @return {number}
 */
proto.proto.RoomMessage.prototype.getAdditionalType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.proto.RoomMessage.prototype.setAdditionalType = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string additional_data = 24;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getAdditionalData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setAdditionalData = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional ExtraType extra_type = 19;
 * @return {!proto.proto.RoomMessage.ExtraType}
 */
proto.proto.RoomMessage.prototype.getExtraType = function() {
  return /** @type {!proto.proto.RoomMessage.ExtraType} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {!proto.proto.RoomMessage.ExtraType} value */
proto.proto.RoomMessage.prototype.setExtraType = function(value) {
  jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional ChannelExtra channel_extra = 20;
 * @return {?proto.proto.RoomMessage.ChannelExtra}
 */
proto.proto.RoomMessage.prototype.getChannelExtra = function() {
  return /** @type{?proto.proto.RoomMessage.ChannelExtra} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage.ChannelExtra, 20));
};


/** @param {?proto.proto.RoomMessage.ChannelExtra|undefined} value */
proto.proto.RoomMessage.prototype.setChannelExtra = function(value) {
  jspb.Message.setWrapperField(this, 20, value);
};


proto.proto.RoomMessage.prototype.clearChannelExtra = function() {
  this.setChannelExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomMessage.prototype.hasChannelExtra = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional uint64 document_id = 27;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setDocumentId = function(value) {
  jspb.Message.setProto3StringIntField(this, 27, value);
};


/**
 * optional uint64 version_document_id = 28;
 * @return {string}
 */
proto.proto.RoomMessage.prototype.getVersionDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, "0"));
};


/** @param {string} value */
proto.proto.RoomMessage.prototype.setVersionDocumentId = function(value) {
  jspb.Message.setProto3StringIntField(this, 28, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomDraft = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomDraft, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomDraft.displayName = 'proto.proto.RoomDraft';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomDraft.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomDraft.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomDraft} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomDraft.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    replyTo: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    draftTime: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomDraft}
 */
proto.proto.RoomDraft.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomDraft;
  return proto.proto.RoomDraft.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomDraft} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomDraft}
 */
proto.proto.RoomDraft.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setReplyTo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDraftTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomDraft.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomDraft.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomDraft} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomDraft.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReplyTo();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getDraftTime();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.proto.RoomDraft.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.RoomDraft.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 reply_to = 2;
 * @return {string}
 */
proto.proto.RoomDraft.prototype.getReplyTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.RoomDraft.prototype.setReplyTo = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint32 draft_time = 3;
 * @return {number}
 */
proto.proto.RoomDraft.prototype.getDraftTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.RoomDraft.prototype.setDraftTime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Room = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Room, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Room.displayName = 'proto.proto.Room';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Room.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Room.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Room} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Room.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    initials: jspb.Message.getFieldWithDefault(msg, 4, ""),
    color: jspb.Message.getFieldWithDefault(msg, 5, ""),
    unreadCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastMessage: (f = msg.getLastMessage()) && proto.proto.RoomMessage.toObject(includeInstance, f),
    readOnly: jspb.Message.getFieldWithDefault(msg, 8, false),
    isParticipant: jspb.Message.getFieldWithDefault(msg, 9, false),
    draft: (f = msg.getDraft()) && proto.proto.RoomDraft.toObject(includeInstance, f),
    firstUnreadMessage: (f = msg.getFirstUnreadMessage()) && proto.proto.RoomMessage.toObject(includeInstance, f),
    roomMute: jspb.Message.getFieldWithDefault(msg, 15, 0),
    pinId: jspb.Message.getFieldWithDefault(msg, 16, "0"),
    pinnedMessage: (f = msg.getPinnedMessage()) && proto.proto.RoomMessage.toObject(includeInstance, f),
    priority: jspb.Message.getFieldWithDefault(msg, 18, 0),
    chatRoomExtra: (f = msg.getChatRoomExtra()) && proto.proto.ChatRoom.toObject(includeInstance, f),
    groupRoomExtra: (f = msg.getGroupRoomExtra()) && proto.proto.GroupRoom.toObject(includeInstance, f),
    channelRoomExtra: (f = msg.getChannelRoomExtra()) && proto.proto.ChannelRoom.toObject(includeInstance, f),
    appId: jspb.Message.getFieldWithDefault(msg, 19, 0),
    permission: (f = msg.getPermission()) && proto.proto.RoomAccess.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Room}
 */
proto.proto.Room.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Room;
  return proto.proto.Room.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Room} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Room}
 */
proto.proto.Room.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.Room.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInitials(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnreadCount(value);
      break;
    case 7:
      var value = new proto.proto.RoomMessage;
      reader.readMessage(value,proto.proto.RoomMessage.deserializeBinaryFromReader);
      msg.setLastMessage(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadOnly(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsParticipant(value);
      break;
    case 10:
      var value = new proto.proto.RoomDraft;
      reader.readMessage(value,proto.proto.RoomDraft.deserializeBinaryFromReader);
      msg.setDraft(value);
      break;
    case 14:
      var value = new proto.proto.RoomMessage;
      reader.readMessage(value,proto.proto.RoomMessage.deserializeBinaryFromReader);
      msg.setFirstUnreadMessage(value);
      break;
    case 15:
      var value = /** @type {!proto.proto.RoomMute} */ (reader.readEnum());
      msg.setRoomMute(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setPinId(value);
      break;
    case 17:
      var value = new proto.proto.RoomMessage;
      reader.readMessage(value,proto.proto.RoomMessage.deserializeBinaryFromReader);
      msg.setPinnedMessage(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriority(value);
      break;
    case 11:
      var value = new proto.proto.ChatRoom;
      reader.readMessage(value,proto.proto.ChatRoom.deserializeBinaryFromReader);
      msg.setChatRoomExtra(value);
      break;
    case 12:
      var value = new proto.proto.GroupRoom;
      reader.readMessage(value,proto.proto.GroupRoom.deserializeBinaryFromReader);
      msg.setGroupRoomExtra(value);
      break;
    case 13:
      var value = new proto.proto.ChannelRoom;
      reader.readMessage(value,proto.proto.ChannelRoom.deserializeBinaryFromReader);
      msg.setChannelRoomExtra(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAppId(value);
      break;
    case 20:
      var value = new proto.proto.RoomAccess;
      reader.readMessage(value,proto.proto.RoomAccess.deserializeBinaryFromReader);
      msg.setPermission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Room.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Room.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Room} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Room.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInitials();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUnreadCount();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getLastMessage();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.RoomMessage.serializeBinaryToWriter
    );
  }
  f = message.getReadOnly();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsParticipant();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDraft();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.proto.RoomDraft.serializeBinaryToWriter
    );
  }
  f = message.getFirstUnreadMessage();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.proto.RoomMessage.serializeBinaryToWriter
    );
  }
  f = message.getRoomMute();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getPinId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      16,
      f
    );
  }
  f = message.getPinnedMessage();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.proto.RoomMessage.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getChatRoomExtra();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.proto.ChatRoom.serializeBinaryToWriter
    );
  }
  f = message.getGroupRoomExtra();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.proto.GroupRoom.serializeBinaryToWriter
    );
  }
  f = message.getChannelRoomExtra();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.proto.ChannelRoom.serializeBinaryToWriter
    );
  }
  f = message.getAppId();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getPermission();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.proto.RoomAccess.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.Room.Type = {
  CHAT: 0,
  GROUP: 1,
  CHANNEL: 2
};

/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.proto.Room.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.Room.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.proto.Room.Type}
 */
proto.proto.Room.prototype.getType = function() {
  return /** @type {!proto.proto.Room.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.proto.Room.Type} value */
proto.proto.Room.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.proto.Room.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.Room.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string initials = 4;
 * @return {string}
 */
proto.proto.Room.prototype.getInitials = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.Room.prototype.setInitials = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.proto.Room.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.Room.prototype.setColor = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 unread_count = 6;
 * @return {number}
 */
proto.proto.Room.prototype.getUnreadCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.proto.Room.prototype.setUnreadCount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional RoomMessage last_message = 7;
 * @return {?proto.proto.RoomMessage}
 */
proto.proto.Room.prototype.getLastMessage = function() {
  return /** @type{?proto.proto.RoomMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage, 7));
};


/** @param {?proto.proto.RoomMessage|undefined} value */
proto.proto.Room.prototype.setLastMessage = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.proto.Room.prototype.clearLastMessage = function() {
  this.setLastMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasLastMessage = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool read_only = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.Room.prototype.getReadOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.proto.Room.prototype.setReadOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool is_participant = 9;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.Room.prototype.getIsParticipant = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.proto.Room.prototype.setIsParticipant = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional RoomDraft draft = 10;
 * @return {?proto.proto.RoomDraft}
 */
proto.proto.Room.prototype.getDraft = function() {
  return /** @type{?proto.proto.RoomDraft} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomDraft, 10));
};


/** @param {?proto.proto.RoomDraft|undefined} value */
proto.proto.Room.prototype.setDraft = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.proto.Room.prototype.clearDraft = function() {
  this.setDraft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasDraft = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional RoomMessage first_unread_message = 14;
 * @return {?proto.proto.RoomMessage}
 */
proto.proto.Room.prototype.getFirstUnreadMessage = function() {
  return /** @type{?proto.proto.RoomMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage, 14));
};


/** @param {?proto.proto.RoomMessage|undefined} value */
proto.proto.Room.prototype.setFirstUnreadMessage = function(value) {
  jspb.Message.setWrapperField(this, 14, value);
};


proto.proto.Room.prototype.clearFirstUnreadMessage = function() {
  this.setFirstUnreadMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasFirstUnreadMessage = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional RoomMute room_mute = 15;
 * @return {!proto.proto.RoomMute}
 */
proto.proto.Room.prototype.getRoomMute = function() {
  return /** @type {!proto.proto.RoomMute} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.proto.RoomMute} value */
proto.proto.Room.prototype.setRoomMute = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional uint64 pin_id = 16;
 * @return {string}
 */
proto.proto.Room.prototype.getPinId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, "0"));
};


/** @param {string} value */
proto.proto.Room.prototype.setPinId = function(value) {
  jspb.Message.setProto3StringIntField(this, 16, value);
};


/**
 * optional RoomMessage pinned_message = 17;
 * @return {?proto.proto.RoomMessage}
 */
proto.proto.Room.prototype.getPinnedMessage = function() {
  return /** @type{?proto.proto.RoomMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomMessage, 17));
};


/** @param {?proto.proto.RoomMessage|undefined} value */
proto.proto.Room.prototype.setPinnedMessage = function(value) {
  jspb.Message.setWrapperField(this, 17, value);
};


proto.proto.Room.prototype.clearPinnedMessage = function() {
  this.setPinnedMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasPinnedMessage = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional uint32 priority = 18;
 * @return {number}
 */
proto.proto.Room.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.proto.Room.prototype.setPriority = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional ChatRoom chat_room_extra = 11;
 * @return {?proto.proto.ChatRoom}
 */
proto.proto.Room.prototype.getChatRoomExtra = function() {
  return /** @type{?proto.proto.ChatRoom} */ (
    jspb.Message.getWrapperField(this, proto.proto.ChatRoom, 11));
};


/** @param {?proto.proto.ChatRoom|undefined} value */
proto.proto.Room.prototype.setChatRoomExtra = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.proto.Room.prototype.clearChatRoomExtra = function() {
  this.setChatRoomExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasChatRoomExtra = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional GroupRoom group_room_extra = 12;
 * @return {?proto.proto.GroupRoom}
 */
proto.proto.Room.prototype.getGroupRoomExtra = function() {
  return /** @type{?proto.proto.GroupRoom} */ (
    jspb.Message.getWrapperField(this, proto.proto.GroupRoom, 12));
};


/** @param {?proto.proto.GroupRoom|undefined} value */
proto.proto.Room.prototype.setGroupRoomExtra = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


proto.proto.Room.prototype.clearGroupRoomExtra = function() {
  this.setGroupRoomExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasGroupRoomExtra = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ChannelRoom channel_room_extra = 13;
 * @return {?proto.proto.ChannelRoom}
 */
proto.proto.Room.prototype.getChannelRoomExtra = function() {
  return /** @type{?proto.proto.ChannelRoom} */ (
    jspb.Message.getWrapperField(this, proto.proto.ChannelRoom, 13));
};


/** @param {?proto.proto.ChannelRoom|undefined} value */
proto.proto.Room.prototype.setChannelRoomExtra = function(value) {
  jspb.Message.setWrapperField(this, 13, value);
};


proto.proto.Room.prototype.clearChannelRoomExtra = function() {
  this.setChannelRoomExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasChannelRoomExtra = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional uint32 app_id = 19;
 * @return {number}
 */
proto.proto.Room.prototype.getAppId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.proto.Room.prototype.setAppId = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional RoomAccess permission = 20;
 * @return {?proto.proto.RoomAccess}
 */
proto.proto.Room.prototype.getPermission = function() {
  return /** @type{?proto.proto.RoomAccess} */ (
    jspb.Message.getWrapperField(this, proto.proto.RoomAccess, 20));
};


/** @param {?proto.proto.RoomAccess|undefined} value */
proto.proto.Room.prototype.setPermission = function(value) {
  jspb.Message.setWrapperField(this, 20, value);
};


proto.proto.Room.prototype.clearPermission = function() {
  this.setPermission(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Room.prototype.hasPermission = function() {
  return jspb.Message.getField(this, 20) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChatRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChatRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.ChatRoom.displayName = 'proto.proto.ChatRoom';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChatRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChatRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChatRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChatRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    peer: (f = msg.getPeer()) && proto.proto.RegisteredUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChatRoom}
 */
proto.proto.ChatRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChatRoom;
  return proto.proto.ChatRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChatRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChatRoom}
 */
proto.proto.ChatRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.RegisteredUser;
      reader.readMessage(value,proto.proto.RegisteredUser.deserializeBinaryFromReader);
      msg.setPeer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChatRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChatRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChatRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChatRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.RegisteredUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegisteredUser peer = 1;
 * @return {?proto.proto.RegisteredUser}
 */
proto.proto.ChatRoom.prototype.getPeer = function() {
  return /** @type{?proto.proto.RegisteredUser} */ (
    jspb.Message.getWrapperField(this, proto.proto.RegisteredUser, 1));
};


/** @param {?proto.proto.RegisteredUser|undefined} value */
proto.proto.ChatRoom.prototype.setPeer = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.proto.ChatRoom.prototype.clearPeer = function() {
  this.setPeer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.ChatRoom.prototype.hasPeer = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.GroupRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.GroupRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.GroupRoom.displayName = 'proto.proto.GroupRoom';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.GroupRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.GroupRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.GroupRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    role: jspb.Message.getFieldWithDefault(msg, 2, 0),
    participantsCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    participantsCountLabel: jspb.Message.getFieldWithDefault(msg, 4, ""),
    participantsCountLimit: jspb.Message.getFieldWithDefault(msg, 5, 0),
    participantsCountLimitLabel: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    avatarCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    avatar: (f = msg.getAvatar()) && proto.proto.Avatar.toObject(includeInstance, f),
    privateExtra: (f = msg.getPrivateExtra()) && proto.proto.GroupRoom.PrivateExtra.toObject(includeInstance, f),
    publicExtra: (f = msg.getPublicExtra()) && proto.proto.GroupRoom.PublicExtra.toObject(includeInstance, f),
    roomRights: (f = msg.getRoomRights()) && GroupChangeMemberRights_pb.GroupChangeMemberRights.MemberRights.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.GroupRoom}
 */
proto.proto.GroupRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.GroupRoom;
  return proto.proto.GroupRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.GroupRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.GroupRoom}
 */
proto.proto.GroupRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.GroupRoom.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.GroupRoom.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParticipantsCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantsCountLabel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParticipantsCountLimit(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantsCountLimitLabel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvatarCount(value);
      break;
    case 9:
      var value = new proto.proto.Avatar;
      reader.readMessage(value,proto.proto.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    case 10:
      var value = new proto.proto.GroupRoom.PrivateExtra;
      reader.readMessage(value,proto.proto.GroupRoom.PrivateExtra.deserializeBinaryFromReader);
      msg.setPrivateExtra(value);
      break;
    case 11:
      var value = new proto.proto.GroupRoom.PublicExtra;
      reader.readMessage(value,proto.proto.GroupRoom.PublicExtra.deserializeBinaryFromReader);
      msg.setPublicExtra(value);
      break;
    case 12:
      var value = new GroupChangeMemberRights_pb.GroupChangeMemberRights.MemberRights;
      reader.readMessage(value,GroupChangeMemberRights_pb.GroupChangeMemberRights.MemberRights.deserializeBinaryFromReader);
      msg.setRoomRights(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.GroupRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.GroupRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.GroupRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getParticipantsCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getParticipantsCountLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParticipantsCountLimit();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getParticipantsCountLimitLabel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAvatarCount();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.proto.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getPrivateExtra();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.proto.GroupRoom.PrivateExtra.serializeBinaryToWriter
    );
  }
  f = message.getPublicExtra();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.proto.GroupRoom.PublicExtra.serializeBinaryToWriter
    );
  }
  f = message.getRoomRights();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      GroupChangeMemberRights_pb.GroupChangeMemberRights.MemberRights.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.GroupRoom.Type = {
  PRIVATE_ROOM: 0,
  PUBLIC_ROOM: 1
};

/**
 * @enum {number}
 */
proto.proto.GroupRoom.Role = {
  MEMBER: 0,
  MODERATOR: 1,
  ADMIN: 2,
  OWNER: 3
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.GroupRoom.PrivateExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.GroupRoom.PrivateExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.GroupRoom.PrivateExtra.displayName = 'proto.proto.GroupRoom.PrivateExtra';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.GroupRoom.PrivateExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.GroupRoom.PrivateExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.GroupRoom.PrivateExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.PrivateExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteLink: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inviteToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.GroupRoom.PrivateExtra}
 */
proto.proto.GroupRoom.PrivateExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.GroupRoom.PrivateExtra;
  return proto.proto.GroupRoom.PrivateExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.GroupRoom.PrivateExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.GroupRoom.PrivateExtra}
 */
proto.proto.GroupRoom.PrivateExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteLink(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.GroupRoom.PrivateExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.GroupRoom.PrivateExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.GroupRoom.PrivateExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.PrivateExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteLink();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInviteToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string invite_link = 1;
 * @return {string}
 */
proto.proto.GroupRoom.PrivateExtra.prototype.getInviteLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.PrivateExtra.prototype.setInviteLink = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invite_token = 2;
 * @return {string}
 */
proto.proto.GroupRoom.PrivateExtra.prototype.getInviteToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.PrivateExtra.prototype.setInviteToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.GroupRoom.PublicExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.GroupRoom.PublicExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.GroupRoom.PublicExtra.displayName = 'proto.proto.GroupRoom.PublicExtra';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.GroupRoom.PublicExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.GroupRoom.PublicExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.GroupRoom.PublicExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.PublicExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.GroupRoom.PublicExtra}
 */
proto.proto.GroupRoom.PublicExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.GroupRoom.PublicExtra;
  return proto.proto.GroupRoom.PublicExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.GroupRoom.PublicExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.GroupRoom.PublicExtra}
 */
proto.proto.GroupRoom.PublicExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.GroupRoom.PublicExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.GroupRoom.PublicExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.GroupRoom.PublicExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.GroupRoom.PublicExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.proto.GroupRoom.PublicExtra.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.PublicExtra.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 1;
 * @return {!proto.proto.GroupRoom.Type}
 */
proto.proto.GroupRoom.prototype.getType = function() {
  return /** @type {!proto.proto.GroupRoom.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.GroupRoom.Type} value */
proto.proto.GroupRoom.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Role role = 2;
 * @return {!proto.proto.GroupRoom.Role}
 */
proto.proto.GroupRoom.prototype.getRole = function() {
  return /** @type {!proto.proto.GroupRoom.Role} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.proto.GroupRoom.Role} value */
proto.proto.GroupRoom.prototype.setRole = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 participants_count = 3;
 * @return {number}
 */
proto.proto.GroupRoom.prototype.getParticipantsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.GroupRoom.prototype.setParticipantsCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string participants_count_label = 4;
 * @return {string}
 */
proto.proto.GroupRoom.prototype.getParticipantsCountLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.prototype.setParticipantsCountLabel = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 participants_count_limit = 5;
 * @return {number}
 */
proto.proto.GroupRoom.prototype.getParticipantsCountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.proto.GroupRoom.prototype.setParticipantsCountLimit = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string participants_count_limit_label = 6;
 * @return {string}
 */
proto.proto.GroupRoom.prototype.getParticipantsCountLimitLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.prototype.setParticipantsCountLimitLabel = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.proto.GroupRoom.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.GroupRoom.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 avatar_count = 8;
 * @return {number}
 */
proto.proto.GroupRoom.prototype.getAvatarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.proto.GroupRoom.prototype.setAvatarCount = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional Avatar avatar = 9;
 * @return {?proto.proto.Avatar}
 */
proto.proto.GroupRoom.prototype.getAvatar = function() {
  return /** @type{?proto.proto.Avatar} */ (
    jspb.Message.getWrapperField(this, proto.proto.Avatar, 9));
};


/** @param {?proto.proto.Avatar|undefined} value */
proto.proto.GroupRoom.prototype.setAvatar = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.proto.GroupRoom.prototype.clearAvatar = function() {
  this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.GroupRoom.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PrivateExtra private_extra = 10;
 * @return {?proto.proto.GroupRoom.PrivateExtra}
 */
proto.proto.GroupRoom.prototype.getPrivateExtra = function() {
  return /** @type{?proto.proto.GroupRoom.PrivateExtra} */ (
    jspb.Message.getWrapperField(this, proto.proto.GroupRoom.PrivateExtra, 10));
};


/** @param {?proto.proto.GroupRoom.PrivateExtra|undefined} value */
proto.proto.GroupRoom.prototype.setPrivateExtra = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.proto.GroupRoom.prototype.clearPrivateExtra = function() {
  this.setPrivateExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.GroupRoom.prototype.hasPrivateExtra = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PublicExtra public_extra = 11;
 * @return {?proto.proto.GroupRoom.PublicExtra}
 */
proto.proto.GroupRoom.prototype.getPublicExtra = function() {
  return /** @type{?proto.proto.GroupRoom.PublicExtra} */ (
    jspb.Message.getWrapperField(this, proto.proto.GroupRoom.PublicExtra, 11));
};


/** @param {?proto.proto.GroupRoom.PublicExtra|undefined} value */
proto.proto.GroupRoom.prototype.setPublicExtra = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.proto.GroupRoom.prototype.clearPublicExtra = function() {
  this.setPublicExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.GroupRoom.prototype.hasPublicExtra = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional GroupChangeMemberRights.MemberRights room_rights = 12;
 * @return {?proto.proto.GroupChangeMemberRights.MemberRights}
 */
proto.proto.GroupRoom.prototype.getRoomRights = function() {
  return /** @type{?proto.proto.GroupChangeMemberRights.MemberRights} */ (
    jspb.Message.getWrapperField(this, GroupChangeMemberRights_pb.GroupChangeMemberRights.MemberRights, 12));
};


/** @param {?proto.proto.GroupChangeMemberRights.MemberRights|undefined} value */
proto.proto.GroupRoom.prototype.setRoomRights = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


proto.proto.GroupRoom.prototype.clearRoomRights = function() {
  this.setRoomRights(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.GroupRoom.prototype.hasRoomRights = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.ChannelRoom.displayName = 'proto.proto.ChannelRoom';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    role: jspb.Message.getFieldWithDefault(msg, 2, 0),
    participantsCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    participantsCountLabel: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    avatarCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    avatar: (f = msg.getAvatar()) && proto.proto.Avatar.toObject(includeInstance, f),
    privateExtra: (f = msg.getPrivateExtra()) && proto.proto.ChannelRoom.PrivateExtra.toObject(includeInstance, f),
    publicExtra: (f = msg.getPublicExtra()) && proto.proto.ChannelRoom.PublicExtra.toObject(includeInstance, f),
    signature: jspb.Message.getFieldWithDefault(msg, 10, false),
    seenId: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    verified: jspb.Message.getFieldWithDefault(msg, 12, false),
    reactionStatus: jspb.Message.getFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelRoom}
 */
proto.proto.ChannelRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelRoom;
  return proto.proto.ChannelRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelRoom}
 */
proto.proto.ChannelRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.ChannelRoom.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.ChannelRoom.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParticipantsCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantsCountLabel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvatarCount(value);
      break;
    case 7:
      var value = new proto.proto.Avatar;
      reader.readMessage(value,proto.proto.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    case 8:
      var value = new proto.proto.ChannelRoom.PrivateExtra;
      reader.readMessage(value,proto.proto.ChannelRoom.PrivateExtra.deserializeBinaryFromReader);
      msg.setPrivateExtra(value);
      break;
    case 9:
      var value = new proto.proto.ChannelRoom.PublicExtra;
      reader.readMessage(value,proto.proto.ChannelRoom.PublicExtra.deserializeBinaryFromReader);
      msg.setPublicExtra(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSignature(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setSeenId(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReactionStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getParticipantsCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getParticipantsCountLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAvatarCount();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getPrivateExtra();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.ChannelRoom.PrivateExtra.serializeBinaryToWriter
    );
  }
  f = message.getPublicExtra();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.proto.ChannelRoom.PublicExtra.serializeBinaryToWriter
    );
  }
  f = message.getSignature();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSeenId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      11,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getReactionStatus();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.ChannelRoom.Type = {
  PRIVATE_ROOM: 0,
  PUBLIC_ROOM: 1
};

/**
 * @enum {number}
 */
proto.proto.ChannelRoom.Role = {
  MEMBER: 0,
  MODERATOR: 1,
  ADMIN: 2,
  OWNER: 3
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelRoom.PrivateExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelRoom.PrivateExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.ChannelRoom.PrivateExtra.displayName = 'proto.proto.ChannelRoom.PrivateExtra';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelRoom.PrivateExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelRoom.PrivateExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelRoom.PrivateExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.PrivateExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteLink: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inviteToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelRoom.PrivateExtra}
 */
proto.proto.ChannelRoom.PrivateExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelRoom.PrivateExtra;
  return proto.proto.ChannelRoom.PrivateExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelRoom.PrivateExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelRoom.PrivateExtra}
 */
proto.proto.ChannelRoom.PrivateExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteLink(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelRoom.PrivateExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelRoom.PrivateExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelRoom.PrivateExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.PrivateExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteLink();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInviteToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string invite_link = 1;
 * @return {string}
 */
proto.proto.ChannelRoom.PrivateExtra.prototype.getInviteLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.ChannelRoom.PrivateExtra.prototype.setInviteLink = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invite_token = 2;
 * @return {string}
 */
proto.proto.ChannelRoom.PrivateExtra.prototype.getInviteToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.ChannelRoom.PrivateExtra.prototype.setInviteToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChannelRoom.PublicExtra = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChannelRoom.PublicExtra, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.ChannelRoom.PublicExtra.displayName = 'proto.proto.ChannelRoom.PublicExtra';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChannelRoom.PublicExtra.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChannelRoom.PublicExtra.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChannelRoom.PublicExtra} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.PublicExtra.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChannelRoom.PublicExtra}
 */
proto.proto.ChannelRoom.PublicExtra.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChannelRoom.PublicExtra;
  return proto.proto.ChannelRoom.PublicExtra.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChannelRoom.PublicExtra} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChannelRoom.PublicExtra}
 */
proto.proto.ChannelRoom.PublicExtra.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChannelRoom.PublicExtra.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChannelRoom.PublicExtra.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChannelRoom.PublicExtra} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChannelRoom.PublicExtra.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.proto.ChannelRoom.PublicExtra.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.ChannelRoom.PublicExtra.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 1;
 * @return {!proto.proto.ChannelRoom.Type}
 */
proto.proto.ChannelRoom.prototype.getType = function() {
  return /** @type {!proto.proto.ChannelRoom.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.ChannelRoom.Type} value */
proto.proto.ChannelRoom.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Role role = 2;
 * @return {!proto.proto.ChannelRoom.Role}
 */
proto.proto.ChannelRoom.prototype.getRole = function() {
  return /** @type {!proto.proto.ChannelRoom.Role} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.proto.ChannelRoom.Role} value */
proto.proto.ChannelRoom.prototype.setRole = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 participants_count = 3;
 * @return {number}
 */
proto.proto.ChannelRoom.prototype.getParticipantsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.ChannelRoom.prototype.setParticipantsCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string participants_count_label = 4;
 * @return {string}
 */
proto.proto.ChannelRoom.prototype.getParticipantsCountLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.ChannelRoom.prototype.setParticipantsCountLabel = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.proto.ChannelRoom.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.ChannelRoom.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 avatar_count = 6;
 * @return {number}
 */
proto.proto.ChannelRoom.prototype.getAvatarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.proto.ChannelRoom.prototype.setAvatarCount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Avatar avatar = 7;
 * @return {?proto.proto.Avatar}
 */
proto.proto.ChannelRoom.prototype.getAvatar = function() {
  return /** @type{?proto.proto.Avatar} */ (
    jspb.Message.getWrapperField(this, proto.proto.Avatar, 7));
};


/** @param {?proto.proto.Avatar|undefined} value */
proto.proto.ChannelRoom.prototype.setAvatar = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.proto.ChannelRoom.prototype.clearAvatar = function() {
  this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.ChannelRoom.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PrivateExtra private_extra = 8;
 * @return {?proto.proto.ChannelRoom.PrivateExtra}
 */
proto.proto.ChannelRoom.prototype.getPrivateExtra = function() {
  return /** @type{?proto.proto.ChannelRoom.PrivateExtra} */ (
    jspb.Message.getWrapperField(this, proto.proto.ChannelRoom.PrivateExtra, 8));
};


/** @param {?proto.proto.ChannelRoom.PrivateExtra|undefined} value */
proto.proto.ChannelRoom.prototype.setPrivateExtra = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.proto.ChannelRoom.prototype.clearPrivateExtra = function() {
  this.setPrivateExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.ChannelRoom.prototype.hasPrivateExtra = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PublicExtra public_extra = 9;
 * @return {?proto.proto.ChannelRoom.PublicExtra}
 */
proto.proto.ChannelRoom.prototype.getPublicExtra = function() {
  return /** @type{?proto.proto.ChannelRoom.PublicExtra} */ (
    jspb.Message.getWrapperField(this, proto.proto.ChannelRoom.PublicExtra, 9));
};


/** @param {?proto.proto.ChannelRoom.PublicExtra|undefined} value */
proto.proto.ChannelRoom.prototype.setPublicExtra = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.proto.ChannelRoom.prototype.clearPublicExtra = function() {
  this.setPublicExtra(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.ChannelRoom.prototype.hasPublicExtra = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool signature = 10;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.ChannelRoom.prototype.getSignature = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.proto.ChannelRoom.prototype.setSignature = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional uint64 seen_id = 11;
 * @return {string}
 */
proto.proto.ChannelRoom.prototype.getSeenId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/** @param {string} value */
proto.proto.ChannelRoom.prototype.setSeenId = function(value) {
  jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional bool verified = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.ChannelRoom.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.proto.ChannelRoom.prototype.setVerified = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool reaction_status = 13;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.ChannelRoom.prototype.getReactionStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 13, false));
};


/** @param {boolean} value */
proto.proto.ChannelRoom.prototype.setReactionStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Thumbnail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Thumbnail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Thumbnail.displayName = 'proto.proto.Thumbnail';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Thumbnail.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Thumbnail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Thumbnail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Thumbnail.toObject = function(includeInstance, msg) {
  var f, obj = {
    size: jspb.Message.getFieldWithDefault(msg, 1, 0),
    width: jspb.Message.getFieldWithDefault(msg, 2, 0),
    height: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cacheId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mime: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Thumbnail}
 */
proto.proto.Thumbnail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Thumbnail;
  return proto.proto.Thumbnail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Thumbnail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Thumbnail}
 */
proto.proto.Thumbnail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCacheId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Thumbnail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Thumbnail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Thumbnail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Thumbnail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCacheId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int64 size = 1;
 * @return {number}
 */
proto.proto.Thumbnail.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.proto.Thumbnail.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 width = 2;
 * @return {number}
 */
proto.proto.Thumbnail.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.proto.Thumbnail.prototype.setWidth = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 height = 3;
 * @return {number}
 */
proto.proto.Thumbnail.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.Thumbnail.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string cache_id = 4;
 * @return {string}
 */
proto.proto.Thumbnail.prototype.getCacheId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.Thumbnail.prototype.setCacheId = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.proto.Thumbnail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.Thumbnail.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string mime = 6;
 * @return {string}
 */
proto.proto.Thumbnail.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.Thumbnail.prototype.setMime = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.File = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.File, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.File.displayName = 'proto.proto.File';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.File.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.File.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.File} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.File.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0),
    largeThumbnail: (f = msg.getLargeThumbnail()) && proto.proto.Thumbnail.toObject(includeInstance, f),
    smallThumbnail: (f = msg.getSmallThumbnail()) && proto.proto.Thumbnail.toObject(includeInstance, f),
    waveformThumbnail: (f = msg.getWaveformThumbnail()) && proto.proto.Thumbnail.toObject(includeInstance, f),
    width: jspb.Message.getFieldWithDefault(msg, 7, 0),
    height: jspb.Message.getFieldWithDefault(msg, 8, 0),
    duration: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
    cacheId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mime: jspb.Message.getFieldWithDefault(msg, 11, ""),
    publicUrl: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.File}
 */
proto.proto.File.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.File;
  return proto.proto.File.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.File} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.File}
 */
proto.proto.File.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 4:
      var value = new proto.proto.Thumbnail;
      reader.readMessage(value,proto.proto.Thumbnail.deserializeBinaryFromReader);
      msg.setLargeThumbnail(value);
      break;
    case 5:
      var value = new proto.proto.Thumbnail;
      reader.readMessage(value,proto.proto.Thumbnail.deserializeBinaryFromReader);
      msg.setSmallThumbnail(value);
      break;
    case 6:
      var value = new proto.proto.Thumbnail;
      reader.readMessage(value,proto.proto.Thumbnail.deserializeBinaryFromReader);
      msg.setWaveformThumbnail(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDuration(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCacheId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.File.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.File.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.File} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.File.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLargeThumbnail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.Thumbnail.serializeBinaryToWriter
    );
  }
  f = message.getSmallThumbnail();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.Thumbnail.serializeBinaryToWriter
    );
  }
  f = message.getWaveformThumbnail();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.proto.Thumbnail.serializeBinaryToWriter
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getCacheId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPublicUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.proto.File.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.File.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.File.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.File.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 3;
 * @return {number}
 */
proto.proto.File.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.File.prototype.setSize = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Thumbnail large_thumbnail = 4;
 * @return {?proto.proto.Thumbnail}
 */
proto.proto.File.prototype.getLargeThumbnail = function() {
  return /** @type{?proto.proto.Thumbnail} */ (
    jspb.Message.getWrapperField(this, proto.proto.Thumbnail, 4));
};


/** @param {?proto.proto.Thumbnail|undefined} value */
proto.proto.File.prototype.setLargeThumbnail = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.proto.File.prototype.clearLargeThumbnail = function() {
  this.setLargeThumbnail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.File.prototype.hasLargeThumbnail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Thumbnail small_thumbnail = 5;
 * @return {?proto.proto.Thumbnail}
 */
proto.proto.File.prototype.getSmallThumbnail = function() {
  return /** @type{?proto.proto.Thumbnail} */ (
    jspb.Message.getWrapperField(this, proto.proto.Thumbnail, 5));
};


/** @param {?proto.proto.Thumbnail|undefined} value */
proto.proto.File.prototype.setSmallThumbnail = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.proto.File.prototype.clearSmallThumbnail = function() {
  this.setSmallThumbnail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.File.prototype.hasSmallThumbnail = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Thumbnail waveform_thumbnail = 6;
 * @return {?proto.proto.Thumbnail}
 */
proto.proto.File.prototype.getWaveformThumbnail = function() {
  return /** @type{?proto.proto.Thumbnail} */ (
    jspb.Message.getWrapperField(this, proto.proto.Thumbnail, 6));
};


/** @param {?proto.proto.Thumbnail|undefined} value */
proto.proto.File.prototype.setWaveformThumbnail = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.proto.File.prototype.clearWaveformThumbnail = function() {
  this.setWaveformThumbnail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.File.prototype.hasWaveformThumbnail = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 width = 7;
 * @return {number}
 */
proto.proto.File.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.proto.File.prototype.setWidth = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 height = 8;
 * @return {number}
 */
proto.proto.File.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.proto.File.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double duration = 9;
 * @return {number}
 */
proto.proto.File.prototype.getDuration = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.proto.File.prototype.setDuration = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string cache_id = 10;
 * @return {string}
 */
proto.proto.File.prototype.getCacheId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.proto.File.prototype.setCacheId = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string mime = 11;
 * @return {string}
 */
proto.proto.File.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.proto.File.prototype.setMime = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string public_url = 12;
 * @return {string}
 */
proto.proto.File.prototype.getPublicUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.proto.File.prototype.setPublicUrl = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.PostMessageRights = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.PostMessageRights, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.PostMessageRights.displayName = 'proto.proto.PostMessageRights';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.PostMessageRights.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.PostMessageRights.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.PostMessageRights} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.PostMessageRights.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendText: jspb.Message.getFieldWithDefault(msg, 1, false),
    sendMedia: jspb.Message.getFieldWithDefault(msg, 3, false),
    sendGif: jspb.Message.getFieldWithDefault(msg, 4, false),
    sendSticker: jspb.Message.getFieldWithDefault(msg, 5, false),
    sendLink: jspb.Message.getFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.PostMessageRights}
 */
proto.proto.PostMessageRights.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.PostMessageRights;
  return proto.proto.PostMessageRights.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.PostMessageRights} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.PostMessageRights}
 */
proto.proto.PostMessageRights.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendText(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendMedia(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendGif(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendSticker(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.PostMessageRights.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.PostMessageRights.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.PostMessageRights} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.PostMessageRights.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendText();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSendMedia();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSendGif();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSendSticker();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSendLink();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional bool send_text = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PostMessageRights.prototype.getSendText = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.proto.PostMessageRights.prototype.setSendText = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool send_media = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PostMessageRights.prototype.getSendMedia = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.proto.PostMessageRights.prototype.setSendMedia = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool send_gif = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PostMessageRights.prototype.getSendGif = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.proto.PostMessageRights.prototype.setSendGif = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool send_sticker = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PostMessageRights.prototype.getSendSticker = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.proto.PostMessageRights.prototype.setSendSticker = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool send_link = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PostMessageRights.prototype.getSendLink = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.proto.PostMessageRights.prototype.setSendLink = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RoomAccess = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.RoomAccess, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.RoomAccess.displayName = 'proto.proto.RoomAccess';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RoomAccess.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RoomAccess.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RoomAccess} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomAccess.toObject = function(includeInstance, msg) {
  var f, obj = {
    modifyRoom: jspb.Message.getFieldWithDefault(msg, 1, false),
    postMessage: (f = msg.getPostMessage()) && proto.proto.PostMessageRights.toObject(includeInstance, f),
    editMessage: jspb.Message.getFieldWithDefault(msg, 3, false),
    deleteMessage: jspb.Message.getFieldWithDefault(msg, 4, false),
    pinMessage: jspb.Message.getFieldWithDefault(msg, 5, false),
    addMember: jspb.Message.getFieldWithDefault(msg, 6, false),
    banMember: jspb.Message.getFieldWithDefault(msg, 7, false),
    getMember: jspb.Message.getFieldWithDefault(msg, 8, false),
    addAdmin: jspb.Message.getFieldWithDefault(msg, 9, false),
    addStory: jspb.Message.getFieldWithDefault(msg, 10, false),
    deleteStory: jspb.Message.getFieldWithDefault(msg, 11, false),
    showStoryViews: jspb.Message.getFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RoomAccess}
 */
proto.proto.RoomAccess.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RoomAccess;
  return proto.proto.RoomAccess.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RoomAccess} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RoomAccess}
 */
proto.proto.RoomAccess.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setModifyRoom(value);
      break;
    case 2:
      var value = new proto.proto.PostMessageRights;
      reader.readMessage(value,proto.proto.PostMessageRights.deserializeBinaryFromReader);
      msg.setPostMessage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditMessage(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleteMessage(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPinMessage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddMember(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBanMember(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGetMember(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddAdmin(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddStory(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleteStory(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowStoryViews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RoomAccess.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RoomAccess.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RoomAccess} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RoomAccess.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModifyRoom();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPostMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.PostMessageRights.serializeBinaryToWriter
    );
  }
  f = message.getEditMessage();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDeleteMessage();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPinMessage();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAddMember();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getBanMember();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getGetMember();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAddAdmin();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAddStory();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getDeleteStory();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getShowStoryViews();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional bool modify_room = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getModifyRoom = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setModifyRoom = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional PostMessageRights post_message = 2;
 * @return {?proto.proto.PostMessageRights}
 */
proto.proto.RoomAccess.prototype.getPostMessage = function() {
  return /** @type{?proto.proto.PostMessageRights} */ (
    jspb.Message.getWrapperField(this, proto.proto.PostMessageRights, 2));
};


/** @param {?proto.proto.PostMessageRights|undefined} value */
proto.proto.RoomAccess.prototype.setPostMessage = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proto.RoomAccess.prototype.clearPostMessage = function() {
  this.setPostMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.RoomAccess.prototype.hasPostMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool edit_message = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getEditMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setEditMessage = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool delete_message = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getDeleteMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setDeleteMessage = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool pin_message = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getPinMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setPinMessage = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool add_member = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getAddMember = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setAddMember = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool ban_member = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getBanMember = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setBanMember = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool get_member = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getGetMember = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setGetMember = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool add_admin = 9;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getAddAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setAddAdmin = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool add_story = 10;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getAddStory = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setAddStory = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool delete_story = 11;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getDeleteStory = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 11, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setDeleteStory = function(value) {
  jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool show_story_views = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.RoomAccess.prototype.getShowStoryViews = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.proto.RoomAccess.prototype.setShowStoryViews = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Wallpaper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Wallpaper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Wallpaper.displayName = 'proto.proto.Wallpaper';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Wallpaper.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Wallpaper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Wallpaper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Wallpaper.toObject = function(includeInstance, msg) {
  var f, obj = {
    file: (f = msg.getFile()) && proto.proto.File.toObject(includeInstance, f),
    color: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Wallpaper}
 */
proto.proto.Wallpaper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Wallpaper;
  return proto.proto.Wallpaper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Wallpaper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Wallpaper}
 */
proto.proto.Wallpaper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.File;
      reader.readMessage(value,proto.proto.File.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Wallpaper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Wallpaper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Wallpaper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Wallpaper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.File.serializeBinaryToWriter
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional File file = 1;
 * @return {?proto.proto.File}
 */
proto.proto.Wallpaper.prototype.getFile = function() {
  return /** @type{?proto.proto.File} */ (
    jspb.Message.getWrapperField(this, proto.proto.File, 1));
};


/** @param {?proto.proto.File|undefined} value */
proto.proto.Wallpaper.prototype.setFile = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.proto.Wallpaper.prototype.clearFile = function() {
  this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Wallpaper.prototype.hasFile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string color = 2;
 * @return {string}
 */
proto.proto.Wallpaper.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.Wallpaper.prototype.setColor = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Pagination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Pagination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Pagination.displayName = 'proto.proto.Pagination';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Pagination.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Pagination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Pagination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Pagination.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Pagination}
 */
proto.proto.Pagination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Pagination;
  return proto.proto.Pagination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Pagination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Pagination}
 */
proto.proto.Pagination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Pagination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Pagination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Pagination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Pagination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.proto.Pagination.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.proto.Pagination.prototype.setOffset = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.proto.Pagination.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.proto.Pagination.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Favorite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Favorite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Favorite.displayName = 'proto.proto.Favorite';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Favorite.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Favorite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Favorite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Favorite.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    textcolor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bgcolor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    image: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Favorite}
 */
proto.proto.Favorite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Favorite;
  return proto.proto.Favorite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Favorite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Favorite}
 */
proto.proto.Favorite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextcolor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBgcolor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Favorite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Favorite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Favorite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Favorite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTextcolor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBgcolor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.proto.Favorite.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.Favorite.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string textcolor = 2;
 * @return {string}
 */
proto.proto.Favorite.prototype.getTextcolor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.Favorite.prototype.setTextcolor = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string bgcolor = 3;
 * @return {string}
 */
proto.proto.Favorite.prototype.getBgcolor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.Favorite.prototype.setBgcolor = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string value = 4;
 * @return {string}
 */
proto.proto.Favorite.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.Favorite.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string image = 5;
 * @return {string}
 */
proto.proto.Favorite.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.Favorite.prototype.setImage = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DiscoveryField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DiscoveryField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.DiscoveryField.displayName = 'proto.proto.DiscoveryField';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DiscoveryField.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DiscoveryField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DiscoveryField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DiscoveryField.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageurl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    actiontype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    id: jspb.Message.getFieldWithDefault(msg, 5, 0),
    param: jspb.Message.getFieldWithDefault(msg, 6, ""),
    agreement: jspb.Message.getFieldWithDefault(msg, 7, false),
    refresh: jspb.Message.getFieldWithDefault(msg, 8, false),
    agreementslug: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DiscoveryField}
 */
proto.proto.DiscoveryField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DiscoveryField;
  return proto.proto.DiscoveryField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DiscoveryField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DiscoveryField}
 */
proto.proto.DiscoveryField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageurl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.DiscoveryField.ButtonActionType} */ (reader.readEnum());
      msg.setActiontype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setParam(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAgreement(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefresh(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementslug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DiscoveryField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DiscoveryField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DiscoveryField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DiscoveryField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageurl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActiontype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getParam();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAgreement();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getRefresh();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAgreementslug();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.DiscoveryField.ButtonActionType = {
  NONE: 0,
  JOIN_LINK: 1,
  BOT_ACTION: 2,
  USERNAME_LINK: 3,
  WEB_LINK: 4,
  WEB_VIEW_LINK: 5,
  STREAM_PLAY: 6,
  PAY_BY_WALLET: 7,
  PAY_DIRECT: 8,
  REQUEST_PHONE: 9,
  REQUEST_LOCATION: 10,
  SHOW_ALERT: 11,
  PAGE: 12,
  FINANCIAL_MENU: 13,
  BILL_MENU: 14,
  TRAFFIC_BILL_MENU: 15,
  MOBILE_BILL_MENU: 16,
  PHONE_BILL_MENU: 17,
  TOPUP_MENU: 18,
  WALLET_MENU: 19,
  NEARBY_MENU: 20,
  CALL: 21,
  STICKER_SHOP: 22,
  IVAND: 23,
  IVANDQR: 24,
  IVANDLIST: 25,
  IVANDSCORE: 26,
  CARD_TO_CARD: 27,
  FAVORITE_CHANNEL: 28,
  MUSIC: 29,
  CHARITY: 30,
  FUN_SERVICE: 31,
  VIRTUAL_MONEY: 32,
  CITY_SERVICE: 33,
  POLL: 34,
  INTERNET_PACKAGE_MENU: 35,
  FINANCIAL_HISTORY: 36,
  INVITE_FRIEND: 37,
  NEWS: 38,
  ELECTRIC_BILL_MENU: 39,
  BLOCKCHAIN: 40,
  PARSLAND: 41,
  POLL_RESULT: 42,
  VIRTUAL_GIFT_CARD: 43,
  NEWS_DETAIL: 44,
  QRPAY: 45
};

/**
 * optional string imageurl = 1;
 * @return {string}
 */
proto.proto.DiscoveryField.prototype.getImageurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.DiscoveryField.prototype.setImageurl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.proto.DiscoveryField.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.DiscoveryField.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ButtonActionType actiontype = 3;
 * @return {!proto.proto.DiscoveryField.ButtonActionType}
 */
proto.proto.DiscoveryField.prototype.getActiontype = function() {
  return /** @type {!proto.proto.DiscoveryField.ButtonActionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.proto.DiscoveryField.ButtonActionType} value */
proto.proto.DiscoveryField.prototype.setActiontype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 orderid = 4;
 * @return {number}
 */
proto.proto.DiscoveryField.prototype.getOrderid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.proto.DiscoveryField.prototype.setOrderid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 id = 5;
 * @return {number}
 */
proto.proto.DiscoveryField.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.proto.DiscoveryField.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string param = 6;
 * @return {string}
 */
proto.proto.DiscoveryField.prototype.getParam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.DiscoveryField.prototype.setParam = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool agreement = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.DiscoveryField.prototype.getAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.proto.DiscoveryField.prototype.setAgreement = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool refresh = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.DiscoveryField.prototype.getRefresh = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.proto.DiscoveryField.prototype.setRefresh = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string agreementSlug = 9;
 * @return {string}
 */
proto.proto.DiscoveryField.prototype.getAgreementslug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.proto.DiscoveryField.prototype.setAgreementslug = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Discovery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Discovery.repeatedFields_, null);
};
goog.inherits(proto.proto.Discovery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Discovery.displayName = 'proto.proto.Discovery';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Discovery.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Discovery.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Discovery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Discovery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Discovery.toObject = function(includeInstance, msg) {
  var f, obj = {
    model: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scale: jspb.Message.getFieldWithDefault(msg, 2, ""),
    discoveryfieldsList: jspb.Message.toObjectList(msg.getDiscoveryfieldsList(),
    proto.proto.DiscoveryField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Discovery}
 */
proto.proto.Discovery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Discovery;
  return proto.proto.Discovery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Discovery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Discovery}
 */
proto.proto.Discovery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.Discovery.DiscoveryModel} */ (reader.readEnum());
      msg.setModel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScale(value);
      break;
    case 3:
      var value = new proto.proto.DiscoveryField;
      reader.readMessage(value,proto.proto.DiscoveryField.deserializeBinaryFromReader);
      msg.addDiscoveryfields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Discovery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Discovery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Discovery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Discovery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getScale();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscoveryfieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.proto.DiscoveryField.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.Discovery.DiscoveryModel = {
  MODEL1: 0,
  MODEL2: 1,
  MODEL3: 2,
  MODEL4: 3,
  MODEL5: 4,
  MODEL6: 5,
  MODEL7: 6,
  MODEL8: 7,
  MODEL9: 8,
  MODEL10: 9,
  MODEL11: 10
};

/**
 * optional DiscoveryModel model = 1;
 * @return {!proto.proto.Discovery.DiscoveryModel}
 */
proto.proto.Discovery.prototype.getModel = function() {
  return /** @type {!proto.proto.Discovery.DiscoveryModel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.Discovery.DiscoveryModel} value */
proto.proto.Discovery.prototype.setModel = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string scale = 2;
 * @return {string}
 */
proto.proto.Discovery.prototype.getScale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.Discovery.prototype.setScale = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DiscoveryField discoveryfields = 3;
 * @return {!Array<!proto.proto.DiscoveryField>}
 */
proto.proto.Discovery.prototype.getDiscoveryfieldsList = function() {
  return /** @type{!Array<!proto.proto.DiscoveryField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.DiscoveryField, 3));
};


/** @param {!Array<!proto.proto.DiscoveryField>} value */
proto.proto.Discovery.prototype.setDiscoveryfieldsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.proto.DiscoveryField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.DiscoveryField}
 */
proto.proto.Discovery.prototype.addDiscoveryfields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.proto.DiscoveryField, opt_index);
};


proto.proto.Discovery.prototype.clearDiscoveryfieldsList = function() {
  this.setDiscoveryfieldsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.PollField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.PollField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.PollField.displayName = 'proto.proto.PollField';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.PollField.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.PollField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.PollField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.PollField.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageurl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    clicked: jspb.Message.getFieldWithDefault(msg, 4, false),
    sum: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    clickable: jspb.Message.getFieldWithDefault(msg, 6, false),
    label: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.PollField}
 */
proto.proto.PollField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.PollField;
  return proto.proto.PollField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.PollField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.PollField}
 */
proto.proto.PollField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageurl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClicked(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setSum(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClickable(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.PollField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.PollField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.PollField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.PollField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageurl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getClicked();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSum();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getClickable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string imageurl = 1;
 * @return {string}
 */
proto.proto.PollField.prototype.getImageurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.PollField.prototype.setImageurl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 orderid = 2;
 * @return {number}
 */
proto.proto.PollField.prototype.getOrderid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.proto.PollField.prototype.setOrderid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 id = 3;
 * @return {number}
 */
proto.proto.PollField.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.PollField.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool clicked = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PollField.prototype.getClicked = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.proto.PollField.prototype.setClicked = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint64 sum = 5;
 * @return {string}
 */
proto.proto.PollField.prototype.getSum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.PollField.prototype.setSum = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional bool clickable = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.PollField.prototype.getClickable = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.proto.PollField.prototype.setClickable = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string label = 7;
 * @return {string}
 */
proto.proto.PollField.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.PollField.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Poll = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Poll.repeatedFields_, null);
};
goog.inherits(proto.proto.Poll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Poll.displayName = 'proto.proto.Poll';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Poll.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Poll.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Poll.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Poll} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Poll.toObject = function(includeInstance, msg) {
  var f, obj = {
    model: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scale: jspb.Message.getFieldWithDefault(msg, 2, ""),
    max: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pollfieldsList: jspb.Message.toObjectList(msg.getPollfieldsList(),
    proto.proto.PollField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Poll}
 */
proto.proto.Poll.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Poll;
  return proto.proto.Poll.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Poll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Poll}
 */
proto.proto.Poll.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.Discovery.DiscoveryModel} */ (reader.readEnum());
      msg.setModel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScale(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMax(value);
      break;
    case 4:
      var value = new proto.proto.PollField;
      reader.readMessage(value,proto.proto.PollField.deserializeBinaryFromReader);
      msg.addPollfields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Poll.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Poll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Poll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Poll.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getScale();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMax();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPollfieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.proto.PollField.serializeBinaryToWriter
    );
  }
};


/**
 * optional Discovery.DiscoveryModel model = 1;
 * @return {!proto.proto.Discovery.DiscoveryModel}
 */
proto.proto.Poll.prototype.getModel = function() {
  return /** @type {!proto.proto.Discovery.DiscoveryModel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.proto.Discovery.DiscoveryModel} value */
proto.proto.Poll.prototype.setModel = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string scale = 2;
 * @return {string}
 */
proto.proto.Poll.prototype.getScale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.Poll.prototype.setScale = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 max = 3;
 * @return {number}
 */
proto.proto.Poll.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.Poll.prototype.setMax = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PollField pollfields = 4;
 * @return {!Array<!proto.proto.PollField>}
 */
proto.proto.Poll.prototype.getPollfieldsList = function() {
  return /** @type{!Array<!proto.proto.PollField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.PollField, 4));
};


/** @param {!Array<!proto.proto.PollField>} value */
proto.proto.Poll.prototype.setPollfieldsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.proto.PollField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.PollField}
 */
proto.proto.Poll.prototype.addPollfields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.proto.PollField, opt_index);
};


proto.proto.Poll.prototype.clearPollfieldsList = function() {
  this.setPollfieldsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.IVandActivity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.IVandActivity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.IVandActivity.displayName = 'proto.proto.IVandActivity';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.IVandActivity.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.IVandActivity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.IVandActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.IVandActivity.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    score: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.IVandActivity}
 */
proto.proto.IVandActivity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.IVandActivity;
  return proto.proto.IVandActivity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.IVandActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.IVandActivity}
 */
proto.proto.IVandActivity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.IVandActivity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.IVandActivity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.IVandActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.IVandActivity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.proto.IVandActivity.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.IVandActivity.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 score = 2;
 * @return {number}
 */
proto.proto.IVandActivity.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.proto.IVandActivity.prototype.setScore = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 time = 3;
 * @return {number}
 */
proto.proto.IVandActivity.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.IVandActivity.prototype.setTime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplSale = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplSale, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplSale.displayName = 'proto.proto.MplSale';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplSale.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplSale.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplSale} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplSale.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceNumber: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    fromUserId: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    traceNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    payTime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cardNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    rrn: jspb.Message.getFieldWithDefault(msg, 8, 0),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplSale}
 */
proto.proto.MplSale.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplSale;
  return proto.proto.MplSale.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplSale} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplSale}
 */
proto.proto.MplSale.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setInvoiceNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setFromUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTraceNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPayTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRrn(value);
      break;
    case 9:
      var value = /** @type {!proto.proto.MplSale.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplSale.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplSale.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplSale} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplSale.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceNumber();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getFromUserId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getTraceNumber();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPayTime();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRrn();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.MplSale.Status = {
  PENDING_VERIFY: 0,
  SUCCESS: 1,
  FAILED: 2,
  REVERSED: 3
};

/**
 * optional uint64 invoice_number = 1;
 * @return {string}
 */
proto.proto.MplSale.prototype.getInvoiceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.MplSale.prototype.setInvoiceNumber = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 from_user_id = 2;
 * @return {string}
 */
proto.proto.MplSale.prototype.getFromUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.MplSale.prototype.setFromUserId = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 amount = 3;
 * @return {string}
 */
proto.proto.MplSale.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.proto.MplSale.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 trace_number = 4;
 * @return {number}
 */
proto.proto.MplSale.prototype.getTraceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.proto.MplSale.prototype.setTraceNumber = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 pay_time = 5;
 * @return {number}
 */
proto.proto.MplSale.prototype.getPayTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.proto.MplSale.prototype.setPayTime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.proto.MplSale.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.MplSale.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string card_number = 7;
 * @return {string}
 */
proto.proto.MplSale.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.MplSale.prototype.setCardNumber = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 rrn = 8;
 * @return {number}
 */
proto.proto.MplSale.prototype.getRrn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.proto.MplSale.prototype.setRrn = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional Status status = 9;
 * @return {!proto.proto.MplSale.Status}
 */
proto.proto.MplSale.prototype.getStatus = function() {
  return /** @type {!proto.proto.MplSale.Status} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.proto.MplSale.Status} value */
proto.proto.MplSale.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplTransaction.displayName = 'proto.proto.MplTransaction';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    payTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    bill: (f = msg.getBill()) && proto.proto.MplTransaction.Bill.toObject(includeInstance, f),
    topup: (f = msg.getTopup()) && proto.proto.MplTransaction.Topup.toObject(includeInstance, f),
    sales: (f = msg.getSales()) && proto.proto.MplTransaction.Sales.toObject(includeInstance, f),
    cardtocard: (f = msg.getCardtocard()) && proto.proto.MplTransaction.CardToCard.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplTransaction}
 */
proto.proto.MplTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplTransaction;
  return proto.proto.MplTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplTransaction}
 */
proto.proto.MplTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPayTime(value);
      break;
    case 4:
      var value = /** @type {!proto.proto.MplTransaction.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = new proto.proto.MplTransaction.Bill;
      reader.readMessage(value,proto.proto.MplTransaction.Bill.deserializeBinaryFromReader);
      msg.setBill(value);
      break;
    case 6:
      var value = new proto.proto.MplTransaction.Topup;
      reader.readMessage(value,proto.proto.MplTransaction.Topup.deserializeBinaryFromReader);
      msg.setTopup(value);
      break;
    case 7:
      var value = new proto.proto.MplTransaction.Sales;
      reader.readMessage(value,proto.proto.MplTransaction.Sales.deserializeBinaryFromReader);
      msg.setSales(value);
      break;
    case 8:
      var value = new proto.proto.MplTransaction.CardToCard;
      reader.readMessage(value,proto.proto.MplTransaction.CardToCard.deserializeBinaryFromReader);
      msg.setCardtocard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPayTime();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getBill();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.MplTransaction.Bill.serializeBinaryToWriter
    );
  }
  f = message.getTopup();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.proto.MplTransaction.Topup.serializeBinaryToWriter
    );
  }
  f = message.getSales();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.MplTransaction.Sales.serializeBinaryToWriter
    );
  }
  f = message.getCardtocard();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.MplTransaction.CardToCard.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.MplTransaction.Type = {
  NONE: 0,
  BILL: 1,
  TOPUP: 2,
  SALES: 3,
  CARD_TO_CARD: 4
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplTransaction.Bill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplTransaction.Bill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplTransaction.Bill.displayName = 'proto.proto.MplTransaction.Bill';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplTransaction.Bill.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplTransaction.Bill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplTransaction.Bill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Bill.toObject = function(includeInstance, msg) {
  var f, obj = {
    billid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    billtype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    cardnumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    merchantname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    requestdatetime: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    statusdescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
    terminalno: jspb.Message.getFieldWithDefault(msg, 12, 0),
    traceno: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplTransaction.Bill}
 */
proto.proto.MplTransaction.Bill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplTransaction.Bill;
  return proto.proto.MplTransaction.Bill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplTransaction.Bill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplTransaction.Bill}
 */
proto.proto.MplTransaction.Bill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBilltype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardnumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRequestdatetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdescription(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTerminalno(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTraceno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplTransaction.Bill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplTransaction.Bill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplTransaction.Bill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Bill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBilltype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getCardnumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMerchantname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getRequestdatetime();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getStatusdescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTerminalno();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getTraceno();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
};


/**
 * optional string BillId = 1;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getBillid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setBillid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PayId = 2;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getPayid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setPayid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string BillType = 3;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getBilltype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setBilltype = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 Status = 4;
 * @return {number}
 */
proto.proto.MplTransaction.Bill.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Bill.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 Amount = 5;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string CardNumber = 6;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getCardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setCardnumber = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MerchantName = 7;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getMerchantname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setMerchantname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 OrderId = 8;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 RequestDateTime = 9;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getRequestdatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setRequestdatetime = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional uint64 RRN = 10;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string StatusDescription = 11;
 * @return {string}
 */
proto.proto.MplTransaction.Bill.prototype.getStatusdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Bill.prototype.setStatusdescription = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint32 TerminalNo = 12;
 * @return {number}
 */
proto.proto.MplTransaction.Bill.prototype.getTerminalno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Bill.prototype.setTerminalno = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 TraceNo = 13;
 * @return {number}
 */
proto.proto.MplTransaction.Bill.prototype.getTraceno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Bill.prototype.setTraceno = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplTransaction.Topup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplTransaction.Topup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplTransaction.Topup.displayName = 'proto.proto.MplTransaction.Topup';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplTransaction.Topup.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplTransaction.Topup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplTransaction.Topup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Topup.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestermobilenumber: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    chargemobilenumber: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    topuptype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    cardnumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    merchantname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    requestdatetime: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    statusdescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
    terminalno: jspb.Message.getFieldWithDefault(msg, 12, 0),
    traceno: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplTransaction.Topup}
 */
proto.proto.MplTransaction.Topup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplTransaction.Topup;
  return proto.proto.MplTransaction.Topup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplTransaction.Topup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplTransaction.Topup}
 */
proto.proto.MplTransaction.Topup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRequestermobilenumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setChargemobilenumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTopuptype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardnumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRequestdatetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdescription(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTerminalno(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTraceno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplTransaction.Topup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplTransaction.Topup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplTransaction.Topup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Topup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestermobilenumber();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getChargemobilenumber();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getTopuptype();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getCardnumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMerchantname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getRequestdatetime();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getStatusdescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTerminalno();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getTraceno();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
};


/**
 * optional uint64 RequesterMobileNumber = 1;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getRequestermobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setRequestermobilenumber = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 ChargeMobileNumber = 2;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getChargemobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setChargemobilenumber = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint32 TopupType = 3;
 * @return {number}
 */
proto.proto.MplTransaction.Topup.prototype.getTopuptype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Topup.prototype.setTopuptype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 Status = 4;
 * @return {number}
 */
proto.proto.MplTransaction.Topup.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Topup.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 Amount = 5;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string CardNumber = 6;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getCardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setCardnumber = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MerchantName = 7;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getMerchantname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setMerchantname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 OrderId = 8;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 RequestDateTime = 9;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getRequestdatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setRequestdatetime = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional uint64 RRN = 10;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string StatusDescription = 11;
 * @return {string}
 */
proto.proto.MplTransaction.Topup.prototype.getStatusdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Topup.prototype.setStatusdescription = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint32 TerminalNo = 12;
 * @return {number}
 */
proto.proto.MplTransaction.Topup.prototype.getTerminalno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Topup.prototype.setTerminalno = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 TraceNo = 13;
 * @return {number}
 */
proto.proto.MplTransaction.Topup.prototype.getTraceno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Topup.prototype.setTraceno = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplTransaction.Sales = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplTransaction.Sales, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplTransaction.Sales.displayName = 'proto.proto.MplTransaction.Sales';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplTransaction.Sales.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplTransaction.Sales.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplTransaction.Sales} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Sales.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    cardnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    merchantname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    requestdatetime: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    statusdescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
    terminalno: jspb.Message.getFieldWithDefault(msg, 9, 0),
    traceno: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplTransaction.Sales}
 */
proto.proto.MplTransaction.Sales.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplTransaction.Sales;
  return proto.proto.MplTransaction.Sales.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplTransaction.Sales} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplTransaction.Sales}
 */
proto.proto.MplTransaction.Sales.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRequestdatetime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdescription(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTerminalno(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTraceno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplTransaction.Sales.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplTransaction.Sales.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplTransaction.Sales} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.Sales.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getCardnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMerchantname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getRequestdatetime();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      7,
      f
    );
  }
  f = message.getStatusdescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTerminalno();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getTraceno();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional uint32 Status = 1;
 * @return {number}
 */
proto.proto.MplTransaction.Sales.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Sales.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 Amount = 2;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string CardNumber = 3;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getCardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setCardnumber = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string MerchantName = 4;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getMerchantname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setMerchantname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 OrderId = 5;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 RequestDateTime = 6;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getRequestdatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setRequestdatetime = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional uint64 RRN = 7;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional string StatusDescription = 8;
 * @return {string}
 */
proto.proto.MplTransaction.Sales.prototype.getStatusdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.Sales.prototype.setStatusdescription = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 TerminalNo = 9;
 * @return {number}
 */
proto.proto.MplTransaction.Sales.prototype.getTerminalno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Sales.prototype.setTerminalno = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 TraceNo = 10;
 * @return {number}
 */
proto.proto.MplTransaction.Sales.prototype.getTraceno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.Sales.prototype.setTraceno = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MplTransaction.CardToCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MplTransaction.CardToCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MplTransaction.CardToCard.displayName = 'proto.proto.MplTransaction.CardToCard';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MplTransaction.CardToCard.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MplTransaction.CardToCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MplTransaction.CardToCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.CardToCard.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    sourcecardnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    destcardnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    bankname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    destbankname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cardownername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    requestdatetime: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    rrn: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    statusdescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
    traceno: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MplTransaction.CardToCard}
 */
proto.proto.MplTransaction.CardToCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MplTransaction.CardToCard;
  return proto.proto.MplTransaction.CardToCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MplTransaction.CardToCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MplTransaction.CardToCard}
 */
proto.proto.MplTransaction.CardToCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcecardnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestcardnumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestbankname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardownername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrderid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRequestdatetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRrn(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdescription(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTraceno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MplTransaction.CardToCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MplTransaction.CardToCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MplTransaction.CardToCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MplTransaction.CardToCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAmount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getSourcecardnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDestcardnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBankname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDestbankname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCardownername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getRequestdatetime();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
  f = message.getRrn();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getStatusdescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTraceno();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
};


/**
 * optional uint32 Status = 1;
 * @return {number}
 */
proto.proto.MplTransaction.CardToCard.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.CardToCard.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 Amount = 2;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setAmount = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string SourceCardNumber = 3;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getSourcecardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setSourcecardnumber = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string DestCardNumber = 4;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getDestcardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setDestcardnumber = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BankName = 5;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getBankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setBankname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string DestBankName = 6;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getDestbankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setDestbankname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CardOwnerName = 7;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getCardownername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setCardownername = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 OrderId = 8;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 RequestDateTime = 9;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getRequestdatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setRequestdatetime = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional uint64 RRN = 10;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getRrn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setRrn = function(value) {
  jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string StatusDescription = 11;
 * @return {string}
 */
proto.proto.MplTransaction.CardToCard.prototype.getStatusdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.CardToCard.prototype.setStatusdescription = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint32 TraceNo = 13;
 * @return {number}
 */
proto.proto.MplTransaction.CardToCard.prototype.getTraceno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.CardToCard.prototype.setTraceno = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint64 order_id = 1;
 * @return {string}
 */
proto.proto.MplTransaction.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.proto.MplTransaction.prototype.setOrderId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.proto.MplTransaction.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proto.MplTransaction.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 pay_time = 3;
 * @return {number}
 */
proto.proto.MplTransaction.prototype.getPayTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proto.MplTransaction.prototype.setPayTime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Type type = 4;
 * @return {!proto.proto.MplTransaction.Type}
 */
proto.proto.MplTransaction.prototype.getType = function() {
  return /** @type {!proto.proto.MplTransaction.Type} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.proto.MplTransaction.Type} value */
proto.proto.MplTransaction.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Bill bill = 5;
 * @return {?proto.proto.MplTransaction.Bill}
 */
proto.proto.MplTransaction.prototype.getBill = function() {
  return /** @type{?proto.proto.MplTransaction.Bill} */ (
    jspb.Message.getWrapperField(this, proto.proto.MplTransaction.Bill, 5));
};


/** @param {?proto.proto.MplTransaction.Bill|undefined} value */
proto.proto.MplTransaction.prototype.setBill = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.proto.MplTransaction.prototype.clearBill = function() {
  this.setBill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.MplTransaction.prototype.hasBill = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Topup topup = 6;
 * @return {?proto.proto.MplTransaction.Topup}
 */
proto.proto.MplTransaction.prototype.getTopup = function() {
  return /** @type{?proto.proto.MplTransaction.Topup} */ (
    jspb.Message.getWrapperField(this, proto.proto.MplTransaction.Topup, 6));
};


/** @param {?proto.proto.MplTransaction.Topup|undefined} value */
proto.proto.MplTransaction.prototype.setTopup = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.proto.MplTransaction.prototype.clearTopup = function() {
  this.setTopup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.MplTransaction.prototype.hasTopup = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Sales sales = 7;
 * @return {?proto.proto.MplTransaction.Sales}
 */
proto.proto.MplTransaction.prototype.getSales = function() {
  return /** @type{?proto.proto.MplTransaction.Sales} */ (
    jspb.Message.getWrapperField(this, proto.proto.MplTransaction.Sales, 7));
};


/** @param {?proto.proto.MplTransaction.Sales|undefined} value */
proto.proto.MplTransaction.prototype.setSales = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.proto.MplTransaction.prototype.clearSales = function() {
  this.setSales(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.MplTransaction.prototype.hasSales = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional CardToCard cardtocard = 8;
 * @return {?proto.proto.MplTransaction.CardToCard}
 */
proto.proto.MplTransaction.prototype.getCardtocard = function() {
  return /** @type{?proto.proto.MplTransaction.CardToCard} */ (
    jspb.Message.getWrapperField(this, proto.proto.MplTransaction.CardToCard, 8));
};


/** @param {?proto.proto.MplTransaction.CardToCard|undefined} value */
proto.proto.MplTransaction.prototype.setCardtocard = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.proto.MplTransaction.prototype.clearCardtocard = function() {
  this.setCardtocard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.MplTransaction.prototype.hasCardtocard = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * @enum {number}
 */
proto.proto.Gender = {
  UNKNOWN: 0,
  MALE: 1,
  FEMALE: 2
};

/**
 * @enum {number}
 */
proto.proto.Device = {
  UNKNOWN_DEVICE: 0,
  PC: 1,
  TABLET: 2,
  MOBILE: 3
};

/**
 * @enum {number}
 */
proto.proto.Platform = {
  UNKNOWN_PLATFORM: 0,
  ANDROID: 1,
  IOS: 2,
  MAC_OS: 3,
  WINDOWS: 4,
  LINUX: 5,
  BLACK_BERRY: 6
};

/**
 * @enum {number}
 */
proto.proto.Language = {
  EN_US: 0,
  FA_IR: 1
};

/**
 * @enum {number}
 */
proto.proto.RoomMessageType = {
  TEXT: 0,
  IMAGE: 1,
  IMAGE_TEXT: 2,
  VIDEO: 3,
  VIDEO_TEXT: 4,
  AUDIO: 5,
  AUDIO_TEXT: 6,
  VOICE: 7,
  GIF: 8,
  GIF_TEXT: 14,
  FILE: 9,
  FILE_TEXT: 10,
  LOCATION: 11,
  LOG: 12,
  CONTACT: 13,
  WALLET: 15,
  STICKER: 16,
  STORY: 17,
  STORY_REPLY: 18
};

/**
 * @enum {number}
 */
proto.proto.RoomMessageStatus = {
  FAILED: 0,
  SENDING: 1,
  SENT: 2,
  DELIVERED: 3,
  SEEN: 4,
  LISTENED: 5
};

/**
 * @enum {number}
 */
proto.proto.RoomMessageReaction = {
  THUMBS_UP: 0,
  THUMBS_DOWN: 1
};

/**
 * @enum {number}
 */
proto.proto.Originator = {
  USER: 0,
  ROOM: 1
};

/**
 * @enum {number}
 */
proto.proto.ClientAction = {
  CANCEL: 0,
  TYPING: 1,
  SENDING_IMAGE: 2,
  CAPTURING_IMAGE: 3,
  SENDING_VIDEO: 4,
  CAPTURING_VIDEO: 5,
  SENDING_AUDIO: 6,
  RECORDING_VOICE: 7,
  SENDING_VOICE: 8,
  SENDING_DOCUMENT: 9,
  SENDING_GIF: 10,
  SENDING_FILE: 11,
  SENDING_LOCATION: 12,
  CHOOSING_CONTACT: 13,
  PAINTING: 14
};

/**
 * @enum {number}
 */
proto.proto.RoomType = {
  CHAT: 0,
  PRIVATE_GROUP: 1,
  PUBLIC_GROUP: 2,
  PRIVATE_CHANNEL: 3,
  PUBLIC_CHANNEL: 4
};

/**
 * @enum {number}
 */
proto.proto.RoomMute = {
  UNMUTE: 0,
  MUTE: 1
};

/**
 * @enum {number}
 */
proto.proto.PrivacyType = {
  USER_STATUS: 0,
  AVATAR: 1,
  GROUP_INVITE: 2,
  CHANNEL_INVITE: 3,
  VOICE_CALLING: 4,
  VIDEO_CALLING: 5,
  SCREEN_SHARING: 6,
  SECRET_CHAT: 7
};

/**
 * @enum {number}
 */
proto.proto.PrivacyLevel = {
  ALLOW_ALL: 0,
  DENY_ALL: 1,
  ALLOW_CONTACTS: 2
};

goog.object.extend(exports, proto.proto);
